//import { faTwitter, faFacebookF, faPinterestP, faInstagram, faYoutube, faFlickr, faGoogle, faAmazon, faLinkedin, faSnapchat, faMicrosoft, faPlaystation } from '@fortawesome/free-brands-svg-icons';
import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
// import { URL_PROTOCAL } from './../components/Common/Constant';
// import { SocialShareTwo } from "../components/ThemeTwo/SocialShareTwo/SocialShareTwo";
// import { SocialShareThree } from "../components/ThemeThree/SocialShareThree/SocialShareThree";
import { BreakingNews } from './../components/BreakingNews/BreakingNews';
import { Cell } from './../components/Common/Cell';
import { Link } from './../components/Common/Link';
import { Row } from './../components/Common/Row';
import { Text } from './../components/Common/Text';
import { Textnode } from './../components/Common/Textnode';
import { GridView } from './../components/GridView/Grid';
import { ListView } from './../components/ListView/List';
import { Header } from './../components/Header/Header';
import { HeaderAmp } from './../components/HeaderAmp/HeaderAmp';
import { Footer } from './../components/Footer/Footer';
import { FooterAmp } from './../components/FooterAmp/FooterAmp';
import createCache from '@emotion/cache';
import { IGrapeComponentTO } from './../interfaces/IGrapeComponentTO';
import { BreadCrumbs } from './../components/BreadCrumbs/BreadCrumbs';
import { BreadCrumbsAmp } from './../components/BreadCrumbsAmp/BreadCrumbsAmp';
import { HeroLayout } from './../components/HeroLayout/HeroLayout';
import { HeroLayout2 } from './../components/HeroLayout/HeroLayout2';
import { AuthorShow } from './../components/AuthorShow/AuthorShow';
import { PageNotFound } from './../components/PageNotFound/Error';
import { VideoShow } from './../components/VideoShow/VideoShow';
import { GeneralComponent } from './../components/GeneralComponent/GeneralComponent';
import { ArticleShowAmp } from '../components/ArticleShowAmp/ArticleShowAmp';
import { ArticleShow } from '../components/ArticleShow/ArticleShow';
import { SocialShare } from './../components/SocialShare/SocialShare';
import { StaticPage } from './../components/StaticPage/StaticComponent';
import { SlideShow } from './../components/SlideShow/SlideShow';
//import bcrypt from 'bcryptjs-react';
// import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PlayCircleOutlinedIcon from '@mui/icons-material/PlayCircleOutlined';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
// import MicIcon from '@mui/icons-material/Mic';
import PodcastsIcon from '@mui/icons-material/Podcasts';
import CollectionsIcon from '@mui/icons-material/Collections';
import { Tweet } from 'react-twitter-widgets';
import { WebStories } from './../components/WebStories/WebStories';
// thme two

import { BreakingNewsTwo } from './../components/ThemeTwo/BreakingNewsTwo/BreakingNewsTwo';
import { BreakingNewsTicker } from './../components/ThemeTwo/BreakingNewsTicker/BreakingNewsTicker';
import { QuickViewTwo } from './../components/ThemeTwo/QuickViewTwo/QuickViewTwo';
import { ListViewTwo } from './../components/ThemeTwo/ListViewTwo/ListViewTwo';
import { HomeGridViewTwo } from './../components/ThemeTwo/HomeGridViewTwo/HomeGridViewTwo';
import { WebStoriesTwo } from '../components/ThemeTwo/WebStoriesTwo/WebStoriesTwo';
import { HeroLayoutTwo } from '../components/ThemeTwo/HeroLayoutTwo/HeroLayoutTwo';
import { HeroLayoutHrTwo } from '../components/ThemeTwo/HeroLayoutHrTwo/HeroLayoutHrTwo';
import { RhsHomeTwo } from '../components/ThemeTwo/RhsHomeTwo/RhsHomeTwo';
export { RhsHomeOtherTwo } from "../components/ThemeTwo/RhsHomeOtherTwo/RhsHomeOtherTwo";
import { GridViewTwo } from '../components/ThemeTwo/GridViewTwo/GridViewTwo';
import { WebStoriesListTwo } from '../components/ThemeTwo/WebStoriesListTwo/WebStoriesListTwo';
import { MediaListTwo } from '../components/ThemeTwo/MediaListTwo/MediaListTwo';
import { PhotoListTwo } from '../components/ThemeTwo/PhotoListTwo/PhotoListTwo';
import { ArticleShowTwo } from '../components/ThemeTwo/ArticleShowTwo/ArticleShowTwo';
import { liveBlog } from '../components/ThemeTwo/liveBlog/liveBlog';
import { VideoShowTwo } from '../components/ThemeTwo/VideoShowTwo/VideoShowTwo';
import { PodcastTwo } from '../components/ThemeTwo/PodcastTwo/PodcastTwo';
import { SlideShowTwo } from '../components/ThemeTwo/SlideShowTwo/SlideShowTwo';
import { FooterTwo } from '../components/ThemeTwo/FooterTwo/FooterTwo';
import { HeaderTwo } from '../components/ThemeTwo/HeaderTwo/HeaderTwo';
// import { otherHeader } from '../components/ThemeTwo/otherHeader/otherHeader';
import { BreadCrumbsTwo } from '../components/ThemeTwo/BreadCrumbsTwo/BreadCrumbsTwo';
import { AuthorShowTwo } from '../components/ThemeTwo/AuthorShowTwo/AuthorShowTwo';
import { StaticPageTwo } from '../components/ThemeTwo/StaticPageTwo/StaticPageTwo';
import { PageNotFoundTwo } from '../components/ThemeTwo/PageNotFoundTwo/PageNotFoundTwo';
import {ContentRestrictionsTwo} from "../components/ThemeTwo/ContentRestrictions/ContentRestrictionsTwo";

// thme two
// theme three
import { ArticleShowThree } from '../components/ThemeThree/ArticleShowThree/ArticleShowThree';
import { AuthorShowThree } from '../components/ThemeThree/AuthorShowThree/AuthorShowThree';
import { BreakingNewsThree } from './../components/ThemeThree/BreakingNewsThree/BreakingNewsThree';
import { BreadCrumbsThree } from '../components/ThemeThree/BreadCrumbsThree/BreadCrumbsThree';
import { BreakingNewsThreeTicker } from './../components/ThemeThree/BreakingNewsThreeTicker/BreakingNewsThreeTicker';
import { QuickViewThree } from './../components/ThemeThree/QuickViewThree/QuickViewThree';
import { ListViewThree } from './../components/ThemeThree/ListViewThree/ListViewThree';
import { HomeGridViewThree } from './../components/ThemeThree/HomeGridViewThree/HomeGridViewThree';
import { WebStoriesThree } from '../components/ThemeThree/WebStoriesThree/WebStoriesThree';
import { HeroLayoutThree } from '../components/ThemeThree/HeroLayoutThree/HeroLayoutThree';
import { HeroLayoutHrThree } from '../components/ThemeThree/HeroLayoutHrThree/HeroLayoutHrThree';
import { RhsHomeThree } from '../components/ThemeThree/RhsHomeThree/RhsHomeThree';
import { RhsHomeOtherThree } from "../components/ThemeThree/RhsHomeOtherThree/RhsHomeOtherThree";
import { GridViewThree } from '../components/ThemeThree/GridViewThree/GridViewThree';
import { WebStoriesListThree } from '../components/ThemeThree/WebStoriesListThree/WebStoriesListThree';
import { MediaListThree } from '../components/ThemeThree/MediaListThree/MediaListThree';
import { PhotoListThree } from '../components/ThemeThree/PhotoListThree/PhotoListThree';
import { HomePhotoGallery } from '../components/ThemeThree/HomePhotoGallery/HomePhotoGallery';
import { HomeWebStories } from '../components/ThemeThree/HomeWebStories/HomeWebStories';
import { VideoShowThree } from '../components/ThemeThree/VideoShowThree/VideoShowThree';
import { PodcastThree } from '../components/ThemeThree/PodcastThree/PodcastThree';
import { SlideShowThree } from '../components/ThemeThree/SlideShowThree/SlideShowThree';
import { FooterThree } from '../components/ThemeThree/FooterThree/FooterThree';
import { HeaderThree } from '../components/ThemeThree/HeaderThree/HeaderThree';
import { HomeHeaderThree } from '../components/ThemeThree/HomeHeaderThree/HomeHeaderThree';
import { HeroLayoutwithHeader } from '../components/ThemeThree/HeroLayoutwithHeader/HeroLayoutwithHeader';
import { StaticPageThree } from '../components/ThemeThree/StaticPageThree/StaticPageThree';
import { PageNotFoundThree } from '../components/ThemeThree/PageNotFoundThree/PageNotFoundThree';
import { FourLinks } from '../components/ThemeThree/FourLinks/FourLinks';
import { HomeFaq } from '../components/ThemeThree/HomeFaq/HomeFaq';
import { FaqList } from '../components/ThemeThree/FaqList/FaqList';
import { Experts } from '../components/ThemeThree/Experts/Experts';
import { OtherListView } from '../components/ThemeThree/OtherListView/OtherListView';
import { QuizShow } from '../components/ThemeThree/QuizShow/QuizShow';
import { SurveyShow } from '../components/ThemeThree/SurveyShow/SurveyShow';
import EmbedGroupSlider from '../components/EmbedGroupSlider/EmbedGroupSlider';
import iconsSprites from './images/iconsSprites.jpg'
import { PAGEBUILDER_URLS } from '../components/Common/Constant';

// ebd theme three
import Parser from 'html-react-parser';
import parseHTML from 'html-react-parser';
//import parse, { HTMLReactParserOptions, DOMNode  } from 'html-react-parser';
// import React from 'react';

import React, { FC, useEffect, useRef, useState } from 'react';

interface AdSlotProps {
  headScript: string;
  bodyScript: string;
  slotNumber: number;
  adSize?: string;
  componentName: string;
}
declare global {
  interface Window {
    googletag: any;
  }
}
import { RhsHomeOtherTwo } from '../components/ThemeTwo/RhsHomeOtherTwo/RhsHomeOtherTwo';

import { ArticleShowTwoAmp } from '../components/ThemeTwo/ArticleShowTwoAmp/ArticleShowTwoAmp';
import { ampLiveBlog } from '../components/ThemeTwo/ampLiveBlog/ampLiveBlog';
import { HeaderTwoAmp } from '../components/ThemeTwo/HeaderTwoAmp/HeaderTwoAmp';
import { FooterTwoAmp } from '../components/ThemeTwo/FooterTwoAmp/FooterTwoAmp';
import { BreadCrumbsTwoAmp } from '../components/ThemeTwo/BreadCrumbsTwoAmp/BreadCrumbsTwoAmp';
import { PhotoShowTwoAmp } from '../components/ThemeTwo/PhotoShowTwoAmp/PhotoShowTwoAmp';
import { VideoShowTwoAmp } from '../components/ThemeTwo/VideoShowTwoAmp/VideoShowTwoAmp';
import MediaPlayerWrapper from '../components/ThemeTwo/MediaPlayerWrapper';

// ThemeThree AMP
import { ArticleShowThreeAmp } from '../components/ThemeThree/ArticleShowThreeAmp/ArticleShowThreeAmp';
import { HeaderThreeAmp } from '../components/ThemeThree/HeaderThreeAmp/HeaderThreeAmp';
import { FooterThreeAmp } from '../components/ThemeThree/FooterThreeAmp/FooterThreeAmp';
import { BreadCrumbsThreeAmp } from '../components/ThemeThree/BreadCrumbsThreeAmp/BreadCrumbsThreeAmp';
import { PhotoShowThreeAmp } from '../components/ThemeThree/PhotoShowThreeAmp/PhotoShowThreeAmp';
import { VideoShowThreeAmp } from '../components/ThemeThree/VideoShowThreeAmp/VideoShowThreeAmp';
import { AddScripts } from '../components/AddScripts/AddScripts';
// import  AddScriptsTwo  from '../components/ThemeTwo/AddScriptsTwo/AddScriptsTwo';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import EmbedSlider from "../components/EmbedSlider/EmbedSlider";
import EmbedPoll from "../components/EmbedPoll/EmbedPoll"
// import { FrontAwesomeIcon } from '@fortawesome/react-frontawesome'; 
// import { faFilePdf } from '@fortawesome/free-solid-svg-icons';

import { parseDocument, DomUtils } from "htmlparser2";
import { isDesktop } from "react-device-detect";
import { getGlobalUtilContext } from './context';
// import { useEffect, useState } from 'react';

// import MediaPlayerWrapperThree from '../components/ThemeThree/MediaPlayerWrapper';

// End ThemeThree AMP

// const seoData = {
//   type: '',
//   viewport: '',
//   title: '',
//   description: '',
//   keywords: '',
//   pageUrl: '',
//   robots: '',
//   ogTitle: '',
//   ogUrl: '',
//   ogImage: '',
//   ogDescription: '',
//   ogType: '',
//   ogSiteName: '',
//   ogImageWidth: '',
//   ogImageHeight: '',
//   imageHeight: '',
//   imageWidth: '',
//   twitterUrl: '',
//   twitterImage: '',
//   twitterTitle: '',
//   twitterDescription: '',
//   twitterCard: '',
//   twitterSite: '',
//   fbAdmins: '',
//   fbPages: '',
//   fbAppId: '',
//   googleSiteVerification: '',
//   newsKeywords: '',
//   mobileWebAppCapable: '',
//   themeColor: '',
//   appleMobileWebAppCapable: '',
//   handheldFriendly: '',
//   mobileOptimized: '',
//   xUACompatible: '',
//   contentType: '',
//   contentLanguage: '',
//   yKey: '',
//   canonical: '',
//   alternate: '',
//   amphtml: '',
//   websiteName: '',
//   websiteUrl: '',
//   logoUrl: '',
//   logoHeight: '',
//   logoWidth: '',
//   navigationItems: [],
//   thumbnailUrl: '',
//   publishedDate: '',
//   modifiedDate: '',
//   uploadDate: '',
//   author: [],
//   articleBody: '',
//   duration: '',
//   googleSchema: '',
//   slideShowdata: [],
//   breadcrumbs: []
//   headerNavigationItems: [],
//   footerNavigationItems: [],
//   videoEmbeds: [],
//   videocmsEmbeds: [],
//   coverageStartTime: '',
//   coverageEndTime: '',
//   liveBlogUpdate: [],
//   eventLocation: '',
//   sectionName: '',
//   isLive: ''

// };

export const setCmsSeoData = (props: any, response: any, component: any, slideShowdata: any = null) => {
  // console.log("Generate SEO data function is called !!");
  if (typeof document !== 'undefined' && undefined !== document && document
    && PAGEBUILDER_URLS.some(domain => window.location.origin.includes(domain))) {
    return;
  }
  try {

    if (response !== undefined && Object.keys(response).length > 0) {
      let seoData: any = {};
      seoData.mobileWebAppCapable = "yes";
      seoData.appleMobileWebAppCapable = "yes";
      if (component == "ArticleShow" || component == "ArticleShowAmp") {
        // console.log("ArticleShow---response  -: ", response);
        seoData.type = 'ArticleShow';
        const imageUrl = getImageUrl(response.it.id, getImageSize(response.it.imageid), 1280, 720, response.it.pubInfo.baseDomain, false, props.CONSTANTS);

        //SMA SEO META DATA SET
        if (response.it.entityExtension && response.it.entityExtension.smagroup && response.it.entityExtension.smagroup.socialmediaassets
          && Array.isArray(response.it.entityExtension.smagroup.socialmediaassets) && response.it.entityExtension.smagroup.socialmediaassets.length > 0) {
          for (let i = 0; i < (response.it.entityExtension.smagroup.socialmediaassets.length); i++) {
            let temp = response.it.entityExtension.smagroup.socialmediaassets[i];
            if (temp && temp.type != undefined && temp.type && temp.type == "facebook") {
              if (temp.smaheading) seoData.ogTitle = temp.smaheading;
              if (temp.smadescription) seoData.ogDescription = temp.smadescription;
              if (temp.smaimage && temp.smaimage.cmsembed && temp.smaimage.cmsembed.msid) {
                seoData.ogImage = getImageUrl(temp.smaimage.cmsembed.msid, null, 1280, 720, null, false, props.CONSTANTS);
              }
            }
            else if (temp && temp.type != undefined && temp.type && temp.type == "twitter") {
              if (temp.smaheading) seoData.twitterTitle = temp.smaheading;
              if (temp.smadescription) seoData.twitterDescription = temp.smadescription;
              if (temp.smaimage && temp.smaimage.cmsembed && temp.smaimage.cmsembed.msid) {
                seoData.twitterImage = getImageUrl(temp.smaimage.cmsembed.msid, null, 1280, 720, null, false, props.CONSTANTS);
              }
            }
          }
        }
        if (!seoData.ogImage && response.it.metaInfo) {
          if (response.it.metaInfo.OriginalImageHeightPx) { seoData.ogImageHeight = response.it.metaInfo.OriginalImageHeightPx; }
          if (response.it.metaInfo.OriginalImageWidthPx) { seoData.ogImageWidth = response.it.metaInfo.OriginalImageWidthPx; }
        }
        if (response.it.metaInfo && response.it.metaInfo.OriginalImageHeightPx) { seoData.imageHeight = response.it.metaInfo.OriginalImageHeightPx; }
        if (response.it.metaInfo && response.it.metaInfo.OriginalImageWidthPx) { seoData.imageWidth = response.it.metaInfo.OriginalImageWidthPx; }
        if (imageUrl) seoData.thumbnailUrl = imageUrl;
        if (!seoData.ogImage && imageUrl) seoData.ogImage = imageUrl;
        if (!seoData.twitterImage && imageUrl) seoData.twitterImage = imageUrl;
        if (!seoData.ogTitle && response.it.metaInfo && response.it.metaInfo.Alttitle) seoData.ogTitle = response.it.metaInfo.Alttitle;
        else if (!seoData.ogTitle && response.it.hl) seoData.ogTitle = extractTextFromHTML(response.it.hl);
        if (!seoData.twitterTitle && response.it.metaInfo && response.it.metaInfo.Alttitle) seoData.twitterTitle = response.it.metaInfo.Alttitle;
        else if (!seoData.twitterTitle && response.it.hl) seoData.twitterTitle = extractTextFromHTML(response.it.hl);


        if (response.it.metaDescription) seoData.description = response.it.metaDescription;
        else if (response.it.metaInfo && response.it.metaInfo.Altdescription) seoData.description = response.it.metaInfo.Altdescription;
        else if (response.it.syn) seoData.description = response.it.syn;
        if (seoData.twitterDescription) { }
        else if (response.it.metaDescription) seoData.twitterDescription = response.it.metaDescription;
        else if (response.it.metaInfo && response.it.metaInfo.Altdescription) seoData.twitterDescription = response.it.metaInfo.Altdescription;
        else if (response.it.syn) seoData.twitterDescription = response.it.syn;
        if (seoData.ogDescription) { }
        else if (response.it.metaDescription) seoData.ogDescription = response.it.metaDescription;
        else if (response.it.metaInfo && response.it.metaInfo.Altdescription) seoData.ogDescription = response.it.metaInfo.Altdescription;
        else if (response.it.syn) seoData.ogDescription = response.it.syn;

        if (response.it.metaInfo && response.it.metaInfo.kws) seoData.keywords = response.it.metaInfo.kws;
        else if (response.it.metaInfo && response.it.metaInfo.MetaKeywords) seoData.keywords = response.it.metaInfo.MetaKeywords;
        else if (response.it.metaKews) seoData.keywords = response.it.metaKews;
        if (response.it.metaInfo && response.it.metaInfo.kws) seoData.newsKeywords = response.it.metaInfo.kws;
        else if (response.it.metaInfo && response.it.metaInfo.MetaKeywords) seoData.newsKeywords = response.it.metaInfo.MetaKeywords;
        else if (response.it.metaKews) seoData.newsKeywords = response.it.metaKews;

        if (response.it.hl) seoData.title = extractTextFromHTML(response.it.hl);

        if (response.it.wu) seoData.ogUrl = response.it.wu;
        if (response.it.wu) seoData.twitterUrl = response.it.wu;

        if (response.tn) seoData.ogType = response.tn;
        if (response.it.lang) seoData.contentLanguage = response.it.lang;

        if (response.it.sec) seoData.sectionName = getLastPathSegment(response.it.sec);

        if (response.it.cu) seoData.canonical = response.it.cu;
        else if (response.it.metaInfo && response.it.metaInfo.canonicalURL) seoData.canonical = response.it.metaInfo.canonicalURL;
        else if (response.it.wu) seoData.canonical = response.it.wu;

        if (response.it.metaInfo && (!response.it.metaInfo.AMPStory || response.it.metaInfo.AMPStory === "1") && response.it.wu && (!response.it.primeId || response.it.primeId == 0)) {
          if (response.it.wu.includes("/articleshow/")) {
            if (!response.it.wu.includes("/amp_articleshow/")) {
              seoData.amphtml = response.it.wu.replace(/\/articleshow\/(?=[^\/]*$)/, "/amp_articleshow/");
            } else { seoData.amphtml = response.it.wu }
          }
          else if (response.it.wu.includes("/preview_articleshow/")) {
            if (!response.it.wu.includes("/preview_amp_articleshow/")) {
              seoData.amphtml = response.it.wu.replace(/\/preview_articleshow\/(?=[^\/]*$)/, "/preview_amp_articleshow/");
            } else { seoData.amphtml = response.it.wu }
          }
        }

        if (response.it.metaInfo && response.it.metaInfo.NoindexAndNofollow && response.it.metaInfo.NoindexAndNofollow == "1") {
          seoData.noindexAndNofollow = true;
        }

        if (response.it.published) seoData.publishedDate = response.it.published;
        if (response.it.updated) seoData.modifiedDate = response.it.updated;
        if (response.it.authors) seoData.author = response.it.authors;
        // if(response.it.sec) seoData.sectionPath = response.it.sec.replace(/^\/+|\/+$/g, '').split('/');
        if (response.it.processStory && Object.keys(response.it.processStory).length > 0) {
          response.it.processStory.forEach((item: any) => {
            if (item && item.type && (item.type == "text" || item.type == "link") && item.value) seoData.articleBody = seoData.articleBody ? seoData.articleBody + item.value : item.value;
          });
        }

        if (response.it.seoSchema && Object.keys(response.it.seoSchema).length > 0) {
          seoData.googleSchema = response.it.seoSchema[0];
        }

        if (response.it.cmsembed && Object.keys(response.it.cmsembed).length > 0) {
          response.it.cmsembed.forEach((item: any) => {
            if (item && Object.keys(item).length > 0 && item.cmstype && item.cmstype == "MEDIAVIDEO") {
              if (item.msid && item.thumbsize) item.thumbnailUrl = getImageUrl(item.msid, item.thumbsize, 1280, 720, response.it.pubInfo.baseDomain, false, props.CONSTANTS);
              if (!seoData.videocmsEmbeds) seoData.videocmsEmbeds = [];
              seoData.videocmsEmbeds.push(item);
            }
          });
        }

        // if(response.it.embeds && Object.keys(response.it.embeds).length > 0) {
        //   response.it.embeds.forEach((item: any) => {
        //     if(item && Object.keys(item).length > 0 && item.type && item.type == "SLIKE") {
        //       if(!seoData.videoEmbeds) seoData.videoEmbeds = [];
        //       seoData.videoEmbeds.push(item);
        //     }
        //   });
        // }

        // console.log("ArticleShow---seoData  -: ", seoData);
      }
      // else if (component == "QuizShow" || component == "SurveyShow") {
      //  console.log("QuizShow---response  -: ", response);
      //   seoData.type = 'QuizShow & SurveyShow';
      //   const imageUrl = getImageUrl(response.id, getImageSize(response.imageid), 616, undefined, response.pubInfo.baseDomain, false, props.CONSTANTS);

      // SMA SEO META DATA SET
      //   if (response.entityExtension && response.entityExtension.smagroup && response.entityExtension.smagroup.socialmediaassets
      //     && Array.isArray(response.entityExtension.smagroup.socialmediaassets) && response.entityExtension.smagroup.socialmediaassets.length > 0) {
      //     for (let i = 0; i < (response.entityExtension.smagroup.socialmediaassets.length); i++) {
      //       let temp = response.entityExtension.smagroup.socialmediaassets[i];
      //       if (temp && temp.type != undefined && temp.type && temp.type == "facebook") {
      //         if (temp.smaheading) seoData.ogTitle = temp.smaheading;
      //         if (temp.smadescription) seoData.ogDescription = temp.smadescription;
      //         if (temp.smaimage && temp.smaimage.cmsembed && temp.smaimage.cmsembed.msid) {
      //           seoData.ogImage = getImageUrl(temp.smaimage.cmsembed.msid, null, 616, undefined, null, false, props.CONSTANTS);
      //         }
      //       }
      //       else if (temp && temp.type != undefined && temp.type && temp.type == "twitter") {
      //         if (temp.smaheading) seoData.twitterTitle = temp.smaheading;
      //         if (temp.smadescription) seoData.twitterDescription = temp.smadescription;
      //         if (temp.smaimage && temp.smaimage.cmsembed && temp.smaimage.cmsembed.msid) {
      //           seoData.twitterImage = getImageUrl(temp.smaimage.cmsembed.msid, null, 616, undefined, null, false, props.CONSTANTS);
      //         }
      //       }
      //     }
      //   }
      //   if (!seoData.ogTitle && response.hl) seoData.ogTitle = extractTextFromHTML(response.hl);
      //   if (!seoData.twitterTitle && response.hl) seoData.twitterTitle = extractTextFromHTML(response.hl);
      //   if (!seoData.ogDescription && response.media && response.media.description) seoData.ogDescription = response.media.description;
      //   if (!seoData.twitterDescription && response.media && response.media.description) seoData.twitterDescription = response.media.description;
      //   if (!seoData.ogImage && response.metaInfo && response.metaInfo.OriginalImageWidthPx) seoData.ogImageWidth = response.metaInfo.OriginalImageWidthPx;
      //   if (!seoData.ogImage && response.metaInfo && response.metaInfo.OriginalImageHeightPx) seoData.ogImageHeight = response.metaInfo.OriginalImageHeightPx;
      //   if (!seoData.ogImage && imageUrl) seoData.ogImage = imageUrl;
      //   if (!seoData.twitterImage && imageUrl) seoData.twitterImage = imageUrl;

      //   if (response.media && response.media.description) seoData.description = response.media.description;

      //   if (response.metaInfo && response.metaInfo.kws) seoData.keywords = response.metaInfo.kws;
      //   else if (response.metaKews) seoData.keywords = response.metaKews;
      //   if (response.metaInfo && response.metaInfo.kws) seoData.newsKeywords = response.metaInfo.kws;
      //   else if (response.metaKews) seoData.newsKeywords = response.metaKews;

      //   if (response.hl) seoData.title = extractTextFromHTML(response.hl);
      //   if (response.wu) seoData.ogUrl = response.wu;
      //   if (response.wu) seoData.twitterUrl = response.wu;
      //   if (response.metaInfo && response.metaInfo.OriginalImageWidthPx) seoData.ogImageWidth = response.metaInfo.OriginalImageWidthPx;
      //   if (response.metaInfo && response.metaInfo.OriginalImageHeightPx) seoData.ogImageHeight = response.metaInfo.OriginalImageHeightPx;
      //   if (imageUrl) seoData.ogImage = imageUrl;
      //   if (imageUrl) seoData.twitterImage = imageUrl;
      //   if (response.pubInfo && response.pubInfo.lang) seoData.contentLanguage = response.pubInfo.lang;
      //   if (response.tn) seoData.ogType = response.tn;

      //   if (response.cu) seoData.canonical = response.cu;
      //   else if (response.metaInfo && response.metaInfo.canonicalURL) seoData.canonical = response.metaInfo.canonicalURL;
      //   else if (response.wu) seoData.canonical = response.wu;

      //   if (response.metaInfo && response.metaInfo.NoindexAndNofollow && response.metaInfo.NoindexAndNofollow == "1") {
      //     seoData.noindexAndNofollow = true;
      //   }

      //   if (response.lpt) seoData.publishedDate = response.lpt;
      //   if (response.dl) seoData.uploadDate = response.dl;
      //   if (response.upd) seoData.modifiedDate = response.upd;
      //   if (response.authors) seoData.author = response.authors;
      //  if(response.sec) seoData.sectionPath = response.sec.replace(/^\/+|\/+$/g, '').split('/');
      //   if (response.seoSchema && Object.keys(response.seoSchema).length > 0) seoData.googleSchema = response.seoSchema[0];

      //  console.log("QuizShow---seoData  -: ", seoData);
      // }
      else if (component == "VideoShow" || component == "VideoShowAmp") {
        // console.log("VideoShow---response  -: ", response);
        seoData.type = 'VideoShow';
        const imageUrl = getImageUrl(response.id, getImageSize(response.imageid), 1280, 720, response.pubInfo.baseDomain, false, props.CONSTANTS);

        //SMA SEO META DATA SET
        if (response.entityExtension && response.entityExtension.smagroup && response.entityExtension.smagroup.socialmediaassets
          && Array.isArray(response.entityExtension.smagroup.socialmediaassets) && response.entityExtension.smagroup.socialmediaassets.length > 0) {
          for (let i = 0; i < (response.entityExtension.smagroup.socialmediaassets.length); i++) {
            let temp = response.entityExtension.smagroup.socialmediaassets[i];
            if (temp && temp.type != undefined && temp.type && temp.type == "facebook") {
              if (temp.smaheading) seoData.ogTitle = temp.smaheading;
              if (temp.smadescription) seoData.ogDescription = temp.smadescription;
              if (temp.smaimage && temp.smaimage.cmsembed && temp.smaimage.cmsembed.msid) {
                seoData.ogImage = getImageUrl(temp.smaimage.cmsembed.msid, null, 1280, 720, null, false, props.CONSTANTS);
              }
            }
            else if (temp && temp.type != undefined && temp.type && temp.type == "twitter") {
              if (temp.smaheading) seoData.twitterTitle = temp.smaheading;
              if (temp.smadescription) seoData.twitterDescription = temp.smadescription;
              if (temp.smaimage && temp.smaimage.cmsembed && temp.smaimage.cmsembed.msid) {
                seoData.twitterImage = getImageUrl(temp.smaimage.cmsembed.msid, null, 1280, 720, null, false, props.CONSTANTS);
              }
            }
          }
        }
        if (!seoData.ogTitle && response.hl) seoData.ogTitle = extractTextFromHTML(response.hl);
        if (!seoData.twitterTitle && response.hl) seoData.twitterTitle = extractTextFromHTML(response.hl);
        if (!seoData.ogDescription && response.media && response.media.description) seoData.ogDescription = response.media.description;
        if (!seoData.twitterDescription && response.media && response.media.description) seoData.twitterDescription = response.media.description;
        if (!seoData.ogImage && response.metaInfo && response.metaInfo.OriginalImageWidthPx) seoData.ogImageWidth = response.metaInfo.OriginalImageWidthPx;
        if (!seoData.ogImage && response.metaInfo && response.metaInfo.OriginalImageHeightPx) seoData.ogImageHeight = response.metaInfo.OriginalImageHeightPx;
        if (response.metaInfo && response.metaInfo.OriginalImageWidthPx) seoData.imageWidth = response.metaInfo.OriginalImageWidthPx;
        if (response.metaInfo && response.metaInfo.OriginalImageHeightPx) seoData.imageHeight = response.metaInfo.OriginalImageHeightPx;
        if (imageUrl) seoData.thumbnailUrl = imageUrl;
        if (!seoData.ogImage && imageUrl) seoData.ogImage = imageUrl;
        if (!seoData.twitterImage && imageUrl) seoData.twitterImage = imageUrl;

        if (response.media && response.media.description) seoData.description = response.media.description;

        if (response.metaInfo && response.metaInfo.kws) seoData.keywords = response.metaInfo.kws;
        else if (response.metaKews) seoData.keywords = response.metaKews;
        if (response.metaInfo && response.metaInfo.kws) seoData.newsKeywords = response.metaInfo.kws;
        else if (response.metaKews) seoData.newsKeywords = response.metaKews;

        if (response.hl) seoData.title = extractTextFromHTML(response.hl);
        if (response.wu) seoData.ogUrl = response.wu;
        if (response.wu) seoData.twitterUrl = response.wu;
        if (response.metaInfo && response.metaInfo.OriginalImageWidthPx) seoData.ogImageWidth = response.metaInfo.OriginalImageWidthPx;
        if (response.metaInfo && response.metaInfo.OriginalImageHeightPx) seoData.ogImageHeight = response.metaInfo.OriginalImageHeightPx;
        if (imageUrl) seoData.ogImage = imageUrl;
        if (imageUrl) seoData.twitterImage = imageUrl;
        if (response.pubInfo && response.pubInfo.lang) seoData.contentLanguage = response.pubInfo.lang;
        if (response.tn) seoData.ogType = response.tn;

        if (response.cu) seoData.canonical = response.cu;
        else if (response.metaInfo && response.metaInfo.canonicalURL) seoData.canonical = response.metaInfo.canonicalURL;
        else if (response.wu) seoData.canonical = response.wu;

        if (response.metaInfo && response.metaInfo.NoindexAndNofollow && response.metaInfo.NoindexAndNofollow == "1") {
          seoData.noindexAndNofollow = true;
        }

        if (response.metaInfo && (!response.metaInfo.AMPStory ||  response.metaInfo.AMPStory === "1") && response.wu && (!response.primeId || response.primeId == 0)) {
          if (response.wu.includes("/videoshow/")) {
            if (!response.wu.includes("/amp_videoshow/")) {
              seoData.amphtml = response.wu.replace(/\/videoshow\/(?=[^\/]*$)/, "/amp_videoshow/");
            } else { seoData.amphtml = response.wu }
          }
        }

        if (response.lpt) seoData.publishedDate = response.lpt;
        if (response.dl) seoData.uploadDate = response.dl;
        if (response.upd) seoData.modifiedDate = response.upd;
        if (response.authors) seoData.author = response.authors;
        if (response.media && response.media.durationms) seoData.duration = response.media.durationms;
        if (response.Story) seoData.articleBody = response.Story;
        // if(response.sec) seoData.sectionPath = response.sec.replace(/^\/+|\/+$/g, '').split('/');
        if (response.seoSchema && Object.keys(response.seoSchema).length > 0) seoData.googleSchema = response.seoSchema[0];

        // console.log("VideoShow---seoData  -: ", seoData);
      }
      else if (component == "SlideShow" || component == "SlideShowAmp") {
        // console.log("SlideShow---response  -: ", response);
        seoData.type = 'SlideShow';
        const imageUrl = getImageUrl(response.id, getImageSize(response.imageid), 1280, 720, response.pubInfo.baseDomain, false, props.CONSTANTS);

        //SMA SEO META DATA SET
        if (response.entityExtension && response.entityExtension.smagroup && response.entityExtension.smagroup.socialmediaassets
          && Array.isArray(response.entityExtension.smagroup.socialmediaassets) && response.entityExtension.smagroup.socialmediaassets.length > 0) {
          for (let i = 0; i < (response.entityExtension.smagroup.socialmediaassets.length); i++) {
            let temp = response.entityExtension.smagroup.socialmediaassets[i];
            if (temp && temp.type != undefined && temp.type && temp.type == "facebook") {
              if (temp.smaheading) seoData.ogTitle = temp.smaheading;
              if (temp.smadescription) seoData.ogDescription = temp.smadescription;
              if (temp.smaimage && temp.smaimage.cmsembed && temp.smaimage.cmsembed.msid) {
                seoData.ogImage = getImageUrl(temp.smaimage.cmsembed.msid, null, 1280, 720, null, false, props.CONSTANTS);
              }
            }
            else if (temp && temp.type != undefined && temp.type && temp.type == "twitter") {
              if (temp.smaheading) seoData.twitterTitle = temp.smaheading;
              if (temp.smadescription) seoData.twitterDescription = temp.smadescription;
              if (temp.smaimage && temp.smaimage.cmsembed && temp.smaimage.cmsembed.msid) {
                seoData.twitterImage = getImageUrl(temp.smaimage.cmsembed.msid, null, 1280, 720, null, false, props.CONSTANTS);
              }
            }
          }
        }
        if (!seoData.ogImage && response.imageWidth) seoData.ogImageWidth = response.imageWidth;
        if (!seoData.ogImage && response.imageHeight) seoData.ogImageHeight = response.imageHeight;
        if (response.imageWidth) seoData.imageWidth = response.imageWidth;
        if (response.imageHeight) seoData.imageHeight = response.imageHeight;
        if (imageUrl) seoData.thumbnailUrl = imageUrl;
        if (!seoData.ogImage && imageUrl) seoData.ogImage = imageUrl;
        if (!seoData.twitterImage && imageUrl) seoData.twitterImage = imageUrl;
        if (!seoData.ogTitle && response.hl) seoData.ogTitle = extractTextFromHTML(response.hl);
        if (!seoData.twitterTitle && response.hl) seoData.twitterTitle = extractTextFromHTML(response.hl);

        if (response.seodescription) seoData.description = response.seodescription;
        else if (response.syn) seoData.description = response.syn;
        if (!seoData.ogDescription && response.seodescription) seoData.ogDescription = response.seodescription;
        else if (!seoData.ogDescription && response.syn) seoData.ogDescription = response.syn;
        if (!seoData.twitterDescription && response.seodescription) seoData.twitterDescription = response.seodescription;
        else if (!seoData.twitterDescription && response.syn) seoData.twitterDescription = response.syn;

        if (response.metaInfo && response.metaInfo.kws) seoData.keywords = response.metaInfo.kws;
        else if (response.kws) seoData.keywords = response.kws;
        else if (response.metaKeywords) seoData.keywords = response.metaKeywords;
        if (seoData.keywords) seoData.newsKeywords = seoData.keywords;

        if (response.hl) seoData.title = extractTextFromHTML(response.hl);
        if (response.wu) seoData.ogUrl = response.wu;
        if (response.wu) seoData.twitterUrl = response.wu;
        if (response.tn) seoData.ogType = response.tn;
        if (response.pubInfo && response.pubInfo.lang) seoData.contentLanguage = response.pubInfo.lang;

        if (response.cu) seoData.canonical = response.cu;
        else if (response.metaInfo && response.metaInfo.canonicalURL) seoData.canonical = response.metaInfo.canonicalURL;
        else if (response.wu) seoData.canonical = response.wu;

        if (response.metaInfo && response.metaInfo.NoindexAndNofollow && response.metaInfo.NoindexAndNofollow == "1") {
          seoData.noindexAndNofollow = true;
        }

        if (response.wu && (!response.primeId || response.primeId == 0)) {
          if (response.wu.includes("/photoshow/")) {
            if (!response.wu.includes("/amp_photoshow/")) {
              seoData.amphtml = response.wu.replace(/\/photoshow\/(?=[^\/]*$)/, "/amp_photoshow/");
            } else { seoData.amphtml = response.wu }
          }
          else if (response.wu.includes("/preview_photoshow/")) {
            if (!response.wu.includes("/preview_amp_photoshow/")) {
              seoData.amphtml = response.wu.replace(/\/preview_photoshow\/(?=[^\/]*$)/, "/preview_amp_photoshow/");
            } else { seoData.amphtml = response.wu }
          }
        }

        if (response.seoSchema && Object.keys(response.seoSchema).length > 0) seoData.googleSchema = response.seoSchema[0];

        if (response.lpt) seoData.publishedDate = response.lpt;
        if (response.dl) seoData.uploadDate = response.dl;
        if (response.upd) seoData.modifiedDate = response.upd;
        if (response.author) seoData.author = response.author;
        else if (response.au) seoData.author = [{ name: response.au }];

        // console.log("slideShowdata ::::  "  + slideShowdata);
        if (slideShowdata !== undefined && slideShowdata && Object.keys(slideShowdata).length > 0) {
          seoData.slideShowdata = slideShowdata.map((item: any, index: number) => {
            return {
              "type": item.tn,
              "name": extractTextFromHTML(item.hl),
              "description": item.syn,
              "caption": item.syn,
              "thumbnailUrl": getImageUrl(getImageId(item.imageid), getImageSize(item.imageid), 1280, 720, null, false, props.CONSTANTS),
              "contentUrl": item.wu,
              // "duration": item.duration // as all child items are Images
            }
          })
        }
        // console.log("SlideShow---seoData  -: ", seoData);
      }
      else if (component == "AuthorShow") {
        // console.log("AuthorShow---response  -: ", response);
        seoData.type = 'AuthorShow';
        const imageUrl = getImageUrl(response.id, getImageSize(response.imageid), 1280, 720, response.pubInfo.baseDomain, false, props.CONSTANTS);
        if (imageUrl) seoData.ogImage = imageUrl;
        if (imageUrl) seoData.twitterImage = imageUrl;
        if (imageUrl) seoData.thumbnailUrl = imageUrl;
        if (response.name) seoData.title = response.name;
        if (response.name) seoData.ogTitle = response.name;
        if (response.name) seoData.twitterTitle = response.name;
        if (response.personalprofile && response.personalprofile.bio) seoData.description = response.personalprofile.bio;
        else if (response.name) seoData.description = response.name;
        if (response.personalprofile && response.personalprofile.bio) seoData.ogDescription = response.personalprofile.bio;
        else if (response.name) seoData.ogDescription = response.name;
        if (response.personalprofile && response.personalprofile.bio) seoData.twitterDescription = response.personalprofile.bio;
        else if (response.name) seoData.twitterDescription = response.name;

        if (response.pubInfo && response.pubInfo.lang) seoData.contentLanguage = response.pubInfo.lang;

        if (response.socialmediaprofile && response.socialmediaprofile.facebookprofilepage) seoData.fbPages = response.socialmediaprofile.facebookprofilepage;
        if (response.socialmediaprofile && response.socialmediaprofile.twitterhandle) seoData.twitterSite = response.socialmediaprofile.twitterhandle;

        if (response.seoSchema && Object.keys(response.seoSchema).length > 0) seoData.googleSchema = response.seoSchema[0];

        // console.log("AuthorShow---seoData  -: ", seoData);
      }
      else if (component == "StaticPage") {
        // console.log("StaticPage---response  -: ", response);
        seoData.type = 'StaticPage';
        const imageUrl = getImageUrl(response.it.id, getImageSize(response.it.imageid), 1280, 720, response.it.pubInfo.baseDomain, false, props.CONSTANTS);

        //SMA SEO META DATA SET
        if (response.it.entityExtension && response.it.entityExtension.smagroup && response.it.entityExtension.smagroup.socialmediaassets
          && Array.isArray(response.it.entityExtension.smagroup.socialmediaassets) && response.it.entityExtension.smagroup.socialmediaassets.length > 0) {
          for (let i = 0; i < (response.it.entityExtension.smagroup.socialmediaassets.length); i++) {
            let temp = response.it.entityExtension.smagroup.socialmediaassets[i];
            if (temp && temp.type != undefined && temp.type && temp.type == "facebook") {
              if (temp.smaheading) seoData.ogTitle = temp.smaheading;
              if (temp.smadescription) seoData.ogDescription = temp.smadescription;
              if (temp.smaimage && temp.smaimage.cmsembed && temp.smaimage.cmsembed.msid) {
                seoData.ogImage = getImageUrl(temp.smaimage.cmsembed.msid, null, 1280, 720, null, false, props.CONSTANTS);
              }
            }
            else if (temp && temp.type != undefined && temp.type && temp.type == "twitter") {
              if (temp.smaheading) seoData.twitterTitle = temp.smaheading;
              if (temp.smadescription) seoData.twitterDescription = temp.smadescription;
              if (temp.smaimage && temp.smaimage.cmsembed && temp.smaimage.cmsembed.msid) {
                seoData.twitterImage = getImageUrl(temp.smaimage.cmsembed.msid, null, 1280, 720, null, false, props.CONSTANTS);
              }
            }
          }
        }
        if (!seoData.ogImage && response.it.metaInfo) {
          if (response.it.metaInfo.OriginalImageHeightPx) { seoData.ogImageHeight = response.it.metaInfo.OriginalImageHeightPx; }
          if (response.it.metaInfo.OriginalImageWidthPx) { seoData.ogImageWidth = response.it.metaInfo.OriginalImageWidthPx; }
        }
        if (response.it.metaInfo && response.it.metaInfo.OriginalImageHeightPx) { seoData.imageHeight = response.it.metaInfo.OriginalImageHeightPx; }
        if (response.it.metaInfo && response.it.metaInfo.OriginalImageWidthPx) { seoData.imageWidth = response.it.metaInfo.OriginalImageWidthPx; }
        if (imageUrl) seoData.thumbnailUrl = imageUrl;
        if (!seoData.ogImage && imageUrl) seoData.ogImage = imageUrl;
        if (!seoData.twitterImage && imageUrl) seoData.twitterImage = imageUrl;
        if (!seoData.ogTitle && response.it.metaInfo && response.it.metaInfo.Alttitle) seoData.ogTitle = response.it.metaInfo.Alttitle;
        else if (!seoData.ogTitle && response.it.hl) seoData.ogTitle = extractTextFromHTML(response.it.hl);
        if (!seoData.twitterTitle && response.it.metaInfo && response.it.metaInfo.Alttitle) seoData.twitterTitle = response.it.metaInfo.Alttitle;
        else if (!seoData.twitterTitle && response.it.hl) seoData.twitterTitle = extractTextFromHTML(response.it.hl);

        if (response.it.metaDescription) seoData.description = response.it.metaDescription;
        else if (response.it.metaInfo && response.it.metaInfo.Altdescription) seoData.description = response.it.metaInfo.Altdescription;
        else if (response.it.syn) seoData.description = response.it.syn;
        if (seoData.twitterDescription) { }
        else if (response.it.metaDescription) seoData.twitterDescription = response.it.metaDescription;
        else if (response.it.metaInfo && response.it.metaInfo.Altdescription) seoData.twitterDescription = response.it.metaInfo.Altdescription;
        else if (response.it.syn) seoData.twitterDescription = response.it.syn;
        if (seoData.ogDescription) { }
        else if (response.it.metaDescription) seoData.ogDescription = response.it.metaDescription;
        else if (response.it.metaInfo && response.it.metaInfo.Altdescription) seoData.ogDescription = response.it.metaInfo.Altdescription;
        else if (response.it.syn) seoData.ogDescription = response.it.syn;

        if (response.it.metaInfo && response.it.metaInfo.kws) seoData.keywords = response.it.metaInfo.kws;
        else if (response.it.metaInfo && response.it.metaInfo.MetaKeywords) seoData.keywords = response.it.metaInfo.MetaKeywords;
        else if (response.it.metaKews) seoData.keywords = response.it.metaKews;
        if (response.it.metaInfo && response.it.metaInfo.kws) seoData.newsKeywords = response.it.metaInfo.kws;
        else if (response.it.metaInfo && response.it.metaInfo.MetaKeywords) seoData.newsKeywords = response.it.metaInfo.MetaKeywords;
        else if (response.it.metaKews) seoData.newsKeywords = response.it.metaKews;

        if (response.it.hl) seoData.title = extractTextFromHTML(response.it.hl);

        if (response.it.wu) seoData.ogUrl = response.it.wu;
        if (response.it.wu) seoData.twitterUrl = response.it.wu;

        if (response.tn) seoData.ogType = response.tn;
        if (response.it.lang) seoData.contentLanguage = response.it.lang;

        if (response.it.cu) seoData.canonical = response.it.cu;
        else if (response.it.metaInfo && response.it.metaInfo.canonicalURL) seoData.canonical = response.it.metaInfo.canonicalURL;
        else if (response.it.wu) seoData.canonical = response.it.wu;

        if (response.it.metaInfo && response.it.metaInfo.NoindexAndNofollow && response.it.metaInfo.NoindexAndNofollow == "1") {
          seoData.noindexAndNofollow = true;
        }

        if (response.it.published) seoData.publishedDate = response.it.published;
        if (response.it.updated) seoData.modifiedDate = response.it.updated;
        if (response.it.authors) seoData.author = response.it.authors;
        // if(response.it.sec) seoData.sectionPath = response.it.sec.replace(/^\/+|\/+$/g, '').split('/');
        if (response.it.processStory && Object.keys(response.it.processStory).length > 0) {
          response.it.processStory.forEach((item: any) => {
            if (item && item.type && (item.type == "text" || item.type == "link") && item.value) seoData.articleBody = seoData.articleBody ? seoData.articleBody + item.value : item.value;
          });
        }

        if (response.it.seoSchema && Object.keys(response.it.seoSchema).length > 0) {
          seoData.googleSchema = response.it.seoSchema[0];
        }
        // console.log("StaticPage---seoData  -: ", seoData);
      }
      else if (component == "ListView") {
        // console.log("ListView---response  -: ", response);
        seoData.type = 'ListView';
        const imageUrl = getImageUrl(getImageId(response.imageid), getImageSize(response.imageid), 1280, 720, response.pubInfo.baseDomain, false, props.CONSTANTS);
        if (imageUrl) seoData.ogImage = imageUrl;
        if (imageUrl) seoData.twitterImage = imageUrl;
        if (imageUrl) seoData.thumbnailUrl = imageUrl;
        // if (response.imageWidth) console.log("response.imageWidth  -: ", response.imageWidth);
        // if (response.imageHeight) console.log("response.imageHeight  -: ", response.imageHeight);
        if (response.imageWidth) seoData.ogImageWidth = response.imageWidth;
        if (response.imageHeight) seoData.ogImageHeight = response.imageHeight;
        if (response.imageWidth) seoData.imageWidth = response.imageWidth;
        if (response.imageHeight) seoData.imageHeight = response.imageHeight;

        if (response.metaInfo && response.metaInfo.Altdescription) seoData.description = response.metaInfo.Altdescription;
        else if (response.seodescription) seoData.description = response.seodescription;
        else if (response.syn) seoData.description = response.syn;
        if (response.metaInfo && response.metaInfo.Altdescription) seoData.ogDescription = response.metaInfo.Altdescription;
        else if (response.seodescription) seoData.ogDescription = response.seodescription;
        else if (response.syn) seoData.ogDescription = response.syn;
        if (response.metaInfo && response.metaInfo.Altdescription) seoData.twitterDescription = response.metaInfo.Altdescription;
        else if (response.seodescription) seoData.twitterDescription = response.seodescription;
        else if (response.syn) seoData.twitterDescription = response.syn;

        if (response.metaInfo && response.metaInfo.MetaKeywords) seoData.keywords = response.metaInfo.MetaKeywords;
        else if (response.metaInfo && response.metaInfo.kws) seoData.keywords = response.metaInfo.kws;
        else if (response.kws) seoData.keywords = response.kws;
        if (seoData.keywords) seoData.newsKeywords = seoData.keywords;

        if (response.metaInfo && response.metaInfo.Alttitle) seoData.title = response.metaInfo.Alttitle;
        else if (response.hl) seoData.title = extractTextFromHTML(response.hl);
        if (response.metaInfo && response.metaInfo.Alttitle) seoData.ogTitle = response.metaInfo.Alttitle;
        else if (response.hl) seoData.ogTitle = extractTextFromHTML(response.hl);
        if (response.metaInfo && response.metaInfo.Alttitle) seoData.twitterTitle = response.metaInfo.Alttitle;
        else if (response.hl) seoData.twitterTitle = extractTextFromHTML(response.hl);

        if (response.wu) seoData.ogUrl = response.wu;
        if (response.wu) seoData.twitterUrl = response.wu;
        if (response.tn) seoData.ogType = response.tn;
        if (response.pubInfo && response.pubInfo.lang) seoData.contentLanguage = response.pubInfo.lang;

        if (response.cu) seoData.canonical = response.cu;
        else if (response.metaInfo && response.metaInfo.canonicalURL) seoData.canonical = response.metaInfo.canonicalURL;
        else if (response.wu) seoData.canonical = response.wu;
        if (props && seoData && seoData.canonical) {
          const url = new URL(props.REQUEST_URL, 'http://example.com');
          const queryParams = url.search;  // Output: "?lp=3"
          seoData.canonical = seoData.canonical + queryParams;
        }

        if (response.seoSchema && Object.keys(response.seoSchema).length > 0) seoData.googleSchema = response.seoSchema[0];

        if (response.lpt) seoData.publishedDate = response.lpt;
        if (response.dl) seoData.uploadDate = response.dl;
        if (response.upd) seoData.modifiedDate = response.upd;
        if (response.authors) seoData.author = response.authors;

        // console.log("ListView---seoData  -: ", seoData);
      }
      else if (component == "LiveblogShow") {
        // console.log("LiveblogShow---response  -: ", response);
        seoData.type = 'LiveblogShow';
        const imageUrl = getImageUrl(response.msid, response.thumbsize, 1280, 720, "", false, props.CONSTANTS);
        
        if (response.metainfo && response.metainfo.OriginalImageHeightPx && response.metainfo.OriginalImageHeightPx.value) { seoData.imageHeight = response.metainfo.OriginalImageHeightPx.value; }
        if (response.metainfo && response.metainfo.OriginalImageWidthPx && response.metainfo.OriginalImageWidthPx.value) { seoData.imageWidth = response.metainfo.OriginalImageWidthPx.value; }
        if (imageUrl) {
          seoData.thumbnailUrl = imageUrl;
          seoData.ogImage = imageUrl;
          seoData.twitterImage = imageUrl;
        }
        if (seoData.imageHeight) { seoData.ogImageHeight = seoData.imageHeight; }
        if (seoData.imageWidth) { seoData.ogImageWidth = seoData.imageWidth; }

        if (response.title) seoData.title = extractTextFromHTML(response.title.toString());
        console.log("title ythgjb :: ", seoData.title);
        if (response.metainfo && response.metainfo.OGTITLE && response.metainfo.OGTITLE.value) seoData.ogTitle = extractTextFromHTML(response.metainfo.OGTITLE.value);
        else if (response.metainfo && response.metainfo.Alttitle && response.metainfo.Alttitle.value) seoData.ogTitle = extractTextFromHTML(response.metainfo.Alttitle.value);
        else if (seoData.title) seoData.ogTitle = seoData.title;
        if (response.metainfo && response.metainfo.Alttitle && response.metainfo.Alttitle.value) seoData.twitterTitle = extractTextFromHTML(response.metainfo.Alttitle.value);
        else if (seoData.title) seoData.twitterTitle = seoData.title;

        if (response.metainfo && response.metainfo.Altdescription && response.metainfo.Altdescription.value) seoData.description = extractTextFromHTML(response.metainfo.Altdescription.value);
        else if (response.synopsis) seoData.description = extractTextFromHTML(response.synopsis.toString());
        if (seoData.description) seoData.twitterDescription = seoData.description;
        if (seoData.description) seoData.ogDescription = seoData.description;
        if (response.metainfo && response.metainfo.MetaKeywords && response.metainfo.MetaKeywords.value) seoData.keywords = response.metainfo.MetaKeywords.value;
        else if (Array.isArray(response.keywords) && response.keywords.length > 0) seoData.keywords = getKeyword(response.keywords);
        if (seoData.keywords) seoData.newsKeywords = seoData.keywords;
        if (response.seopath && response.msid) seoData.ogUrl = `/${response.seopath}/liveblog/${response.msid}.html`;
        if (seoData.ogUrl) seoData.twitterUrl = seoData.ogUrl;

        if (response.metainfo && response.metainfo.canonicalURL && response.metainfo.canonicalURL.value) seoData.canonical = response.metainfo.canonicalURL.value;
        else if (seoData.ogUrl) seoData.canonical = seoData.ogUrl;

        // if (response.it.lang) seoData.contentLanguage = response.it.lang;

        if (response.metainfo && response.metainfo.NoindexAndNofollow  && response.metainfo.NoindexAndNofollow.value && response.metainfo.NoindexAndNofollow.value == "1") {
          seoData.noindexAndNofollow = true;
        }
        seoData.ogType = "liveblog";

        if (response.metainfo && (!response.metainfo.AMPStory || (response.metainfo.AMPStory && response.metainfo.AMPStory.value === "1")) && seoData.ogUrl && (!response.primeId || response.primeId == 0)) {
          if (seoData.ogUrl.includes("/liveblog/")) {
            if (!seoData.ogUrl.includes("/amp_liveblog/")) {
              seoData.amphtml = seoData.ogUrl.replace(/\/liveblog\/(?=[^\/]*$)/, "/amp_liveblog/");
            } else { seoData.amphtml = seoData.ogUrl }
          }
        }

        if (response.insertdate) seoData.publishedDate = response.insertdate;
        if (response.updatedate) seoData.modifiedDate = response.updatedate;
        if (response.updatedate) seoData.isLive = isUpdatedWithin24Hours(response.updatedate.toString());
        if (response.metainfo && response.metainfo.COVERAGE_START_DATE && response.metainfo.COVERAGE_START_DATE.value) seoData.coverageStartTime = response.metainfo.COVERAGE_START_DATE.value;
        if (response.metainfo && response.metainfo.COVERAGE_END_DATE && response.metainfo.COVERAGE_END_DATE) seoData.coverageEndTime = response.metainfo.COVERAGE_END_DATE.value;
        if (response.metainfo && response.metainfo.EventLocation && response.metainfo.EventLocation.value) seoData.eventLocation = response.metainfo.EventLocation.value;
        if (response.createdby) seoData.author = response.createdby;
        if (Array.isArray(response.children) && response.children.length>0) {
          seoData.liveBlogUpdate = response.children.map((item: any) => {
            return {
              "title": item.title ? extractTextFromHTML(item.title.toString()) : undefined,
              "insertdate": item.insertdate || undefined,
              "updatedate": item.updatedate || undefined,
              "synopsis": item.synopsis ? extractTextFromHTML(item.synopsis.toString()) : undefined,
            }
          });
        }
        // if(response.it.sec) seoData.sectionPath = response.it.sec.replace(/^\/+|\/+$/g, '').split('/');
        // if (response.it.processStory && Object.keys(response.it.processStory).length > 0) {
        //   response.it.processStory.forEach((item: any) => {
        //     if (item && item.type && (item.type == "text" || item.type == "link") && item.value) seoData.articleBody = seoData.articleBody ? seoData.articleBody + item.value : item.value;
        //   });
        // }

        if (response.seoSchema && Object.keys(response.seoSchema).length > 0) {
          seoData.googleSchema = response.seoSchema[0];
        }
        // console.log("LiveblogShow---seoData  -: ", seoData);
      }
      else if (component == "BreadCrumbs" || component == "BreadCrumbsAmp") {
        // console.log("Breadcrumb---response  -: ", response);
        seoData.type = 'Breadcrumb';
        seoData.breadcrumbs = response.reverse().map((item: any) => {
          return {
            "name": extractTextFromHTML(item.hl),
            "url": item.wu,
          }
        })
      }

      if (props.EXPORTED_DATA !== undefined && Object.keys(props.EXPORTED_DATA).length > 0 && props.EXPORTED_DATA.SEO_DATA !== undefined) {
        if (seoData && Object.keys(seoData).length > 0) {
          props.EXPORTED_DATA.SEO_DATA = seoData;
          // console.log("seoData--exported  -: ", props.EXPORTED_DATA.SEO_DATA);
        }
      }

      return seoData;
    }

  } catch (error) {
    //console.log("error :- ", error);
  }
}

const getLastPathSegment = (path: any) => {
  if (!path || path == "") return undefined;
  const segments = path.split('/').filter(Boolean); // removes empty segments caused by trailing slash
  return segments.length ? segments[segments.length - 1] : undefined;
};

const getKeyword = (keywordList : any): string => {
  let keywordString = "";
  try {
    keywordList.forEach((element: any) => {
      if(element?.name && element.name != "") {
        if(keywordString && keywordString != "") keywordString += ", ";
        keywordString = keywordString + element.name.toString();
      }
    });
  } catch(error) {
    console.log("error : ", error);
  }
  return keywordString;
}

function extractTextFromHTML(htmlString: string | null): string {
  if (!htmlString) return "";
  try {
    const dom = parseDocument(htmlString);
    return DomUtils.textContent(dom);
  } catch (error) {
    console.error("Error in extractTextFromHTML:", error);
    return "";
  }
}

export const appendStyleSheet = (componentName: string, styles: string) => {
  try {
    if (typeof document !== 'undefined' && undefined !== document && document) {
      let iframes: any = document.getElementsByClassName("gjs-frame");
      if (iframes && iframes.length > 0 && typeof iframes[0].contentWindow !== 'undefined') {
        let iframeHead = iframes[0].contentWindow.document.head;
        if (iframeHead) {
          // let alreadyExists = false;
          let existingStyles = iframeHead.getElementsByTagName("style");
          for (let eStyle of existingStyles) {
            if (eStyle.getAttribute("name") && eStyle.getAttribute("name") == componentName) {
              // alreadyExists = true;
              eStyle.remove();
              break;
            }
          }

          // if (!alreadyExists) {
          const style = document.createElement("style");
          iframeHead.appendChild(style);
          style.setAttribute("name", componentName);
          style.innerHTML = styles;
          // }
        }
      }
    }
  } catch (error) {
    //console.log("error :- " + error);
  }
}

export const getClasses = (component: IGrapeComponentTO) => {
  let classes = '';
  if (component && component.classes) {
    classes = component.classes.map(e => e.name).join(' ');
  }
  classes = classes.replace(/\s\s+/g, ' ');
  if ((!classes || classes == ' ') && component && component.classes) {
    return component.classes.join(' ');
  }
  return classes;
};

export const getID = (component: IGrapeComponentTO) => {
  if (component && component.attributes && component.attributes.id) {
    return component.attributes.id;
  }
  return '';
};

export const getTag = (component: any) => {
  let TagName = "div"
  if (component && component.tagName) {
    TagName = component.tagName;
  }
  return TagName;
};

export const getAttr = (component: any, attr: any) => {
  if (component && component.attributes && component.attributes[attr] !== undefined) {
    return component.attributes[attr];
  }
  return '';
};

export function getItemsPerPage(defaultItemsPerPage: number, itemsPerPage: any): number {
  // Check if itemsPerPage is null, undefined, or not a string
  if (itemsPerPage == null || itemsPerPage === undefined || typeof itemsPerPage !== "string") {
    return defaultItemsPerPage;
  }

  // Convert string to integer
  const parsedValue = Number(itemsPerPage);

  // Check if parsedValue is a valid number
  if (isNaN(parsedValue)) {
    return defaultItemsPerPage;
  }

  // Ensure parsedValue is within range
  if (parsedValue < 4) return 4;
  if (parsedValue > 100) return 100;

  return parsedValue;
}

export const getComponent = (json: any[], tData: any = null) => {
  const Components: any = {
    "Row": Row,
    "Cell": Cell,
    "link": Link,
    "text": Text,
    "textnode": Textnode,
    "General Component": GeneralComponent,

    "Breaking News": BreakingNews,
    "Breaking News Two": BreakingNewsTwo,
    "Breaking News Ticker": BreakingNewsTicker,
    "Quick View Two": QuickViewTwo,
    "Home Grid View Two": HomeGridViewTwo,
    "WebStories Two": WebStoriesTwo,
    "HeroLayout Two": HeroLayoutTwo,
    "HeroLayout Hr Two": HeroLayoutHrTwo,
    "RhsHome Two": RhsHomeTwo,
    "RhsHome Other Two": RhsHomeOtherTwo,
    "GridView Two": GridViewTwo,
    "WebStoriesList Two": WebStoriesListTwo,
    "MediaList Two": MediaListTwo,
    "PhotoList Two": PhotoListTwo,
    "Article Show Two": ArticleShowTwo,
    "Liveblog Show Two": liveBlog,
    "Video Show Two": VideoShowTwo,
    "Podcast Two": PodcastTwo,
    "Slide Show Two": SlideShowTwo,
    "Footer Two": FooterTwo,
    "Header Two": HeaderTwo,
    "BreadCrumbs Two": BreadCrumbsTwo,
    "List View Two": ListViewTwo,
    "Author Show Two": AuthorShowTwo,
    "Static Page Two": StaticPageTwo,
    "Page Not Found Two": PageNotFoundTwo,
    "ContentRestrictionsTwo": ContentRestrictionsTwo, 
    "List View": ListView,
    "Grid View": GridView,
    "Grid View2": GridView,
    "Header": Header,
    // "Other Header": otherHeader,
    "Footer": Footer,
    "Bread Crumbs": BreadCrumbs,
    "Hero Layout": HeroLayout,
    "Hero Layout2": HeroLayout2,
    "Author Show": AuthorShow,
    "Page Not Found": PageNotFound,
    "Video Show": VideoShow,
    "Carousel Card Block": GridView,
    "Article Show": ArticleShow,
    "Article Show Amp": ArticleShowAmp,
    "socialShare": SocialShare,
    "Static Page": StaticPage,
    "Slide Show": SlideShow,
    "Similar Stories": ListView,
    "Circular Card Carousel": GridView,
    "Web Stories": WebStories,
    "Web Stories2": WebStories,
    "Header Amp": HeaderAmp,
    "Footer Amp": FooterAmp,
    "Bread Crumbs Amp": BreadCrumbsAmp,
    "Article Show Two Amp": ArticleShowTwoAmp,
    "Amp Liveblog Show Two": ampLiveBlog,
    "Header Two Amp": HeaderTwoAmp,
    "Footer Two Amp": FooterTwoAmp,
    "BreadCrumbs Two Amp": BreadCrumbsTwoAmp,
    "Photo Show Two Amp": PhotoShowTwoAmp,
    "Video Show Two Amp": VideoShowTwoAmp,

    // ThemeTheree
    "Breaking News Three": BreakingNewsThree,
    "Breaking News Three Ticker": BreakingNewsThreeTicker,
    "Quick View Three": QuickViewThree,
    "Home Grid View Three": HomeGridViewThree,
    "WebStories Three": WebStoriesThree,
    "HeroLayout Three": HeroLayoutThree,
    "HeroLayout Hr Three": HeroLayoutHrThree,
    "RhsHome Three": RhsHomeThree,
    "RhsHome Other Three": RhsHomeOtherThree,
    "GridView Three": GridViewThree,
    "WebStoriesList Three": WebStoriesListThree,
    "MediaList Three": MediaListThree,
    "PhotoList Three": PhotoListThree,
    "Home Photo Gallery": HomePhotoGallery,
    "Home Web Stroies": HomeWebStories,
    "Article Show Three": ArticleShowThree,
    "Video Show Three": VideoShowThree,
    "Podcast Three": PodcastThree,
    "Slide Show Three": SlideShowThree,
    "Footer Three": FooterThree,
    "Header Three": HeaderThree,
    "Home Header Three": HomeHeaderThree,
    "BreadCrumbs Three": BreadCrumbsThree,
    "List View Three": ListViewThree,
    "Author Show Three": AuthorShowThree,
    "Static Page Three": StaticPageThree,
    "PageNotFound Three": PageNotFoundThree,
    "Article Show Three Amp": ArticleShowThreeAmp,
    "Header Three Amp": HeaderThreeAmp,
    "Footer Three Amp": FooterThreeAmp,
    "BreadCrumbs Three Amp": BreadCrumbsThreeAmp,
    "Photo Show Three Amp": PhotoShowThreeAmp,
    "Video Show Three Amp": VideoShowThreeAmp,
    "HeroLayout with Header": HeroLayoutwithHeader,
    "Four Links": FourLinks,
    "Home Faq": HomeFaq,
    "Faq List": FaqList,
    "Quiz Show": QuizShow,
    "Survey Show": SurveyShow,
    "Home Web Stories": HomeWebStories,
    "Experts": Experts,
    "OtherList View": OtherListView,
    "Ad Scripts": AddScripts,
    "Ad Scripts Two": AddScripts,
    "Ad Scripts Three": AddScripts,
    "Ad Scripts Amp": AddScripts,
    "Ad Scripts Two Amp": AddScripts,
    "Ad Scripts Three Amp": AddScripts
    // End ThemeTheree
  }

  // const [clientDevice, setClientDevice] = useState({ isDesktop: false, isMobile: false });
  // useEffect(() => {
  //   setClientDevice({ isDesktop, isMobile });
  // }, []);


  return json.map((component, i) => {
    let ComponentName: any = null;
    if (component.name === undefined && component.type === undefined) {
      ComponentName = GeneralComponent;
    } else {
      ComponentName = Components[component.name ? component.name : component.type];
    }

    // if (component.type === "Ad Scripts Amp" || component.type === "Ad Scripts Two") {
    // let completeBodyScript = component.attributes.bodyAdScript + component.attributes.bodyAdMobileScript

    // let completeBodyScript = "";
    // if (isCSR()) {

    //   console.log("Only CSR")
    //   console.log(isDesktop);
    //   console.log(isMobile);

    //   if (clientDevice.isDesktop) {
    //       console.log("it is desktop for breaking news CSR");
    //       completeBodyScript = component.attributes.bodyAdScript
    //   }
    //   else if (clientDevice.isMobile) {
    //       console.log("it is mobile for breaking news CSR");
    //       completeBodyScript =  component.attributes.bodyAdMobileScript
    //   }
    // } 
    // else {
    //   completeBodyScript = `<div></div>`
    // }

    //   if (completeBodyScript === null || completeBodyScript === '') {
    //     return '';
    //   }
    //   return <div className="ad_wrapper"
    //     style={{
    //       textAlign: "center",
    //       maxWidth: component.adSize.split("*")[0] + "px",
    //       minHeight: component.adSize.split("*")[1] + "px",
    //       margin: "0 auto"
    //     }}
    //     dangerouslySetInnerHTML={{
    //       __html: completeBodyScript
    //     }} />;
    // }

    if (!ComponentName) {
      return "";
    }

    if (component.attributes && component.attributes.functions) {
      Object.keys(component.attributes.functions).forEach((i_key: any) => {
        component.attributes[i_key] = eval(component.attributes.functions[i_key]);
      });
    }

    if (component.attributes && component.attributes.version != undefined && ComponentName.version !== +component.attributes.version) {
      //console.log("IMP :: Version is different. Please fix this...");
      // console.log("ComponentName.version : ", typeof ComponentName.version);
      // console.log("component.attributes.version : ", typeof component.attributes.version, " ", component.type, " ", component.attributes.title);
      // return '';
    }

    if (ComponentName && typeof ComponentName.langs !== 'undefined' && undefined !== ComponentName.langs && component.lang) {
      return <span className={'lang_' + component.lang}><ComponentName key={i} data={component} {...component.attributes} transportData={tData}></ComponentName></span>
    }

    return <ComponentName key={i} data={component} {...component.attributes} transportData={tData}></ComponentName>
  });
};

export const getMUICache = () => {
  if (typeof document !== 'undefined' && undefined !== document && document) {
    const classes: any = document.getElementsByClassName("gjs-frame");
    if (classes && classes.length > 0 && typeof classes[0].contentWindow !== 'undefined') {
      const container = classes[0].contentWindow.document.head;
      return createCache({
        key: 'css',
        container: container,
        prepend: true
      });
    }
  }

  return createCache({
    key: 'css',
    prepend: true
  });
}

export const getEndpoint = (props: any, name = "MAIN") => {
  if (props.ENDPOINTS) {
    return props.ENDPOINTS.find((e: any) => e.name === name);
  }

  return null;
}

export const ExtractAGAU = (jsonData: any) => {
  const results: any = [];
  const endpoints = jsonData?.attributes?.ENDPOINTS;
  if (!endpoints || !Array.isArray(endpoints)) {
    // console.error('Invalid jsonData format: ENDPOINTS is missing or not an array.');
    return results; // or throw an error, depending on your application's needs
  }
  endpoints.forEach((endpoint: any) => {
    if (endpoint && endpoint.SSRDataObj && endpoint.SSRDataObj.items && Array.isArray(endpoint.SSRDataObj.items)) {
      endpoint.SSRDataObj.items.forEach((item: any) => {
        if (item.tn === "PHOTOGALLERYSLIDESHOWSECTION") {
          results.push({
            ag: item.ag,
            au: item.au
          });
        }
      });
    }
  });
  return results;
};

export const getAdSlotListCount = (name: string, count: any) => {
  ////console.log('name', name)

  switch (name) {
    case "Grid View": {
      // val = 3; // 4
      count = count - 1;
      break;
    }
    case "Hero Layout": {
      // val = 4; // 5
      count = count - 1;
      break;
    }
  //   case "List View": {
  //     // val = 6; // 7
  //     count = count - 1;
  //     break;
  //   }
    case "Similar Stories": {
      // val = 5; // 6
      count = count - 1;
      break;
    }
  //   case "Carousel Card": {
  //     // val = 27; // 27
  //     count = count;
  //     break;
  //   }
    case "Breaking News": {
      // val = 8; // 10
      count = count - 2;
      break;
    }
    case "Grid View2": {
      // val = 11; // 12
      count = count - 1;
      break;
    }
    case "Hero Layout2": {
      // val = 8; // 9
      count = count - 1;
      break;
    }
    case "Quick View": {
      // val = 7; // 10
      count = count - 3;
      break;
    }
  //   case "PhotoList Two": {
  //     // val = 20; // 20
  //     count = count;
  //     break;
  //   }
  //   case "MediaList Two": {
  //     // val = 20; // 20
  //     count = count;
  //     break;
  //   }
  //   case "List View Two": {
  //     // val = 9; // 10
  //     count = count - 1;
  //     break;
  //   }
  //   case "List View Three": {
  //     // val = 9; // 10
  //     count = count - 1;
  //     break;
  //   }
    case "Related News": {
      // val = 6; // 7 & 6
      count = count - 1;
      break;
    }
    case "GridView Two": {
      // val = 11; // 12
      count = count - 1;
      break;
    }
  }

  return count;
}

export const getUrl = (props: any, pageId: any = 1, isLoadMore = false, name = "MAIN", isNotListing = false, websiteId = "", clientId = "", preview = false) => {
  let url = '';

  const endpoint = getEndpoint(props, name);
  //console.log('props.title',props.title,name)

  if (endpoint && endpoint.queryParams && endpoint.queryParams.hostId && props && props.clientHostId) {
    endpoint.queryParams.hostId = props.clientHostId;
  }
  if (endpoint && endpoint.queryParams && endpoint.queryParams.tenentId && props && props.TENENT_ID) {
    endpoint.queryParams.tenentId = props.TENENT_ID;
  }

  if (endpoint && endpoint.LIVE_API_URL) {
    url = endpoint.LIVE_API_URL;
    if (props.ENV === 'M360_STAGING') {
      url = endpoint.STAG_API_URL;
    }

    if (props.title === "Quiz Show" || props.title === "Survey Show") {
      url += `?msid=${endpoint.queryParams.msid}&fv=${endpoint.queryParams.fv}&hostId=${endpoint.queryParams.hostId}`;
      return url;
    }
    if (props.title == 'Faq List') {
      const endpointMain = getEndpoint(props, "MAIN");
      if (endpointMain !== undefined && endpointMain && endpointMain.queryParams && endpoint !== undefined && endpoint
        && endpoint.queryParams && endpointMain.queryParams.msid && endpoint.queryParams.hostId && /^\d+$/.test(endpointMain.queryParams.msid)) {
        url += `?msid=${endpointMain.queryParams.msid}&fv=${endpoint.queryParams.fv}&hostId=${endpoint.queryParams.hostId}&apiType=d`;

        return url;
      }
    }
    
    if (props.title === "Liveblog Show" || props.title === "Liveblog Show Two" || props.title === "Liveblog Show Three" || props.title === "Amp Liveblog Show" || props.title === "Amp Liveblog Show Two" || props.title === "Amp Liveblog Show Three") {
      url += `${endpoint.queryParams.tenentId}/${endpoint.queryParams.hostId}/${endpoint.queryParams.apiType}/${endpoint.queryParams.msid}.json`;
      return url;
    }

    preview && (url = url.replace("/show/article", "/show/preview/article"));
    preview && (url = url.replace("/listing/get/m360", "/listing/get/preview/m360"));

    if (name == "SEO_URL") {
      const endpointMain = getEndpoint(props, "MAIN");
      if (endpointMain !== undefined && endpointMain && endpointMain.queryParams && endpoint !== undefined && endpoint
        && endpoint.queryParams && endpointMain.queryParams.msid && endpoint.queryParams.hostId && /^\d+$/.test(endpointMain.queryParams.msid)) {
        url += `?msid=${endpointMain.queryParams.msid}&fv=${endpoint.queryParams.fv}&hostId=${endpoint.queryParams.hostId}&apiType=${endpoint.queryParams.apiType}`;

        if (Object.keys(endpoint).indexOf('prime') > -1) {
          url += '&primecase=1';
        }

        return url;
      }
      // else if (endpoint !== undefined && endpoint && endpoint.queryParams) {
      //   url += `?msid=${endpoint.queryParams.msid}&fv=${endpoint.queryParams.fv}&hostId=${endpoint.queryParams.hostId}&apiType=${endpoint.queryParams.apiType}`;

      //   return url;
      // }
      else return '';
    }

    //Case of article show URL
    if (isNotListing && props.title && (props.title === "Article Show" || props.title === "Video Show" || props.title === "Slide Show" || props.title === "Photo Show Two Amp" || props.title === "Photo Show Three Amp" || props.title === "Static Page" || props.title === "Article Show Two" || props.title === "Video Show Two" || props.title === "Slide Show Two" || props.title === "Static Page Two" || props.title === "WebStoriesList Two" || props.title === "Video Show Two Amp" || props.title === "Video Show Three Amp" || props.title === "Home Gallery")) {
      //console.log('endpoint.queryParams',endpoint.queryParams)
      //url += `?msid=${endpoint.queryParams.msid}&fv=${endpoint.queryParams.fv}&hostId=${endpoint.queryParams.hostId}`;
      //return url;
      let queryParams = `?msid=${endpoint.queryParams.msid}&fv=${endpoint.queryParams.fv}&hostId=${endpoint.queryParams.hostId}`;

      // queryParams = "?msid=117727485&fv=1000&hostId=421";
      if (props.authorCard) {
        queryParams += `&au=1`;
      }

      if(props.title === "Article Show" || props.title === "Article Show Two" || props.showRelatedStories) {
        queryParams = queryParams + "&stkw=1";
      }
      if (endpoint.queryParams.count !== undefined && endpoint.queryParams.links !== undefined) {
        queryParams += `&count=${endpoint.queryParams.count}&links=${endpoint.queryParams.links}`;
      }
      return url + queryParams;
    } else if (isNotListing && props.title && (props.title === "Author Show" || props.title === "Author Show Two" || props.title === "Author Show Three")) {
      url += `${endpoint.queryParams.msid}?fv=${endpoint.queryParams.fv}&hostId=${endpoint.queryParams.hostId}`;
      return url;
    } else if (isNotListing && props.title && (props.title === "BreadCrumbs" || props.title === "BreadCrumbs Two" || props.title === "BreadCrumbs Three")) {
      url += `?msid=${endpoint.queryParams.msid}&fv=${endpoint.queryParams.fv}&hostId=${endpoint.queryParams.hostId}&pp=${endpoint.queryParams.pp}&cp=${endpoint.queryParams.cp}&apiType=${endpoint.queryParams.apiType}`;
      return url;
    } else if (isNotListing && props.title && websiteId != "" && (props.title === "Header" || props.title === "Footer" || props.title === "HeaderTwo" || props.title === "FooterTwo" || props.title === "HeroLayoutwithHeader")) {

      url += `?clientId=${clientId}&websiteId=${websiteId}`
      return url;
      // } else if (isNotListing && props.title && (props.title === "Header" || (props.title === "Footer" && name != "FOOTER_STORY")) && endpoint.queryParams && endpoint.queryParams.hostId) {
      //   url += `?&hostId=${endpoint.queryParams.hostId}&key=${props.title.toLowerCase()}&fv=1`
      //   return url;
    } else if (isNotListing && props.title && (props.title === "Header" || props.title === "Footer") && endpoint.queryParams && endpoint.queryParams.hostId) {


      if (name === "TOGGLER_MENU_API") {
        // url += `?hostId=${endpoint.queryParams.hostId}&key=${props.title.toLowerCase()}&fv=1&toggle=true`
        url += `?hostId=${endpoint.queryParams.hostId}&key=${props.title.toLowerCase()}&fv=1`
      }
      else if (name === "BREAD_CRUMBS_API") {
        url += `?msid=${endpoint.queryParams.msid}&fv=${endpoint.queryParams.fv}&hostId=${endpoint.queryParams.hostId}&pp=${endpoint.queryParams.pp}&cp=${endpoint.queryParams.cp}&apiType=nav`;
      }
      else {
        url += `?hostId=${endpoint.queryParams.hostId}&key=${props.title.toLowerCase()}&fv=1`
      }
      return url;
    } else if (isNotListing && props.title && props.title === "Faq List") {
      url += `?msid=${endpoint.queryParams.msid}&fv=${endpoint.queryParams.fv}&hostId=${endpoint.queryParams.hostId}&apiType=${endpoint.queryParams.apiType}`;
      return url;
    } else if (props.title && (props.title === "Breaking News Ticker")) {
      url += `/${endpoint.queryParams.tenantId}/${endpoint.queryParams.hostId}/bnews_list.json`;
      return url;
    } else if (isNotListing) {
      return url;

    }

    let pp = 10;
    if (endpoint.queryParams && endpoint.queryParams.pp !== undefined && endpoint.queryParams.pp) {
      pp = endpoint.queryParams.pp;
    }
    if (props.itemsPerPage && !isNaN(Number(props.itemsPerPage))) {
      let pageNumber = Number(props.itemsPerPage);
      if (pageNumber > 100) { pageNumber = 100; }
      else if (pageNumber < 4) { pageNumber = 4; }
      pp = pageNumber;
    }
    if (props.showAdSlot && (props.adNetwork === 'google' && pageId === 1 || props.adNetwork === 'can')) {
      pp = getAdSlotListCount(props.name, pp);
    }
    if (props.showAdSlot2 && (props.adNetwork2 === 'google' && pageId === 1 || props.adNetwork2 === 'can')) {
      pp = getAdSlotListCount(props.name, pp);
    }

    if (typeof endpoint.queryParams.so != 'undefined') {


      if (endpoint.queryParams.apiType === 'sh' || endpoint.queryParams.apiType === 'ssh') {
        url = url.replace('listing', 'section');


      }
      let cdsDomain = '';
      let authorId = '';
      if (endpoint.queryParams.apiType == 'auth-list') {
        if (typeof props.CONSTANTS.CDS_API !== "undefined") {
          cdsDomain = props.CONSTANTS.CDS_API;
        } else {
          cdsDomain = props.CONSTANTS.API_URL.CDS_API;
        }
        if (typeof window !== 'undefined' && undefined !== window && window && PAGEBUILDER_URLS.some(domain => window.location.origin.includes(domain)) && typeof endpoint.queryParams.authorid != 'undefined') {
          authorId = endpoint.queryParams.authorid;
        } else {
          authorId = endpoint.queryParams.msid;
        }

        //console.log(authorId);
        url = `${cdsDomain}/cds-feed-ext/author/story/list/${authorId}?hostId=${endpoint.queryParams.hostId}&pp=${pp}&cp=${pageId}`;
        // url = `${cdsDomain}/cds-feed-ext/author/story/list/479263154?hostId=387&pp=${pp}&cp=${pageId}`;

        return url;
      } else if (endpoint.queryParams.apiType == 'knowledge-search' || endpoint.queryParams.apiType == 'keyword-search') {
        let keyword = endpoint.queryParams.msid;
        if (isNumeric(keyword)) { keyword = "modi"; }
        let storyType = '';
        if (endpoint.queryParams.ct) {
          storyType = "&type=";
          const mapping: { [key: string]: number } = {
            slideshow: 7,
            video: 1024,
            audio: 1025,
            article: 1001,
            immersivestory: 1035,
            quiz: 27,
            survey: 28,
            liveblog: 22
          };
          endpoint.queryParams.ct = endpoint.queryParams.ct.map((item: any) => mapping[item] || item)
          storyType += endpoint.queryParams.ct;
        }
        if (typeof props.CONSTANTS.CDS_API !== "undefined") {
          cdsDomain = props.CONSTANTS.CDS_API;
        } else {
          cdsDomain = props.CONSTANTS.API_URL.CDS_API;
        }
        url = `${cdsDomain}/cds-feed-ext/jcms/${endpoint.queryParams.apiType.split('-')[0]}?hostId=${endpoint.queryParams.hostId}&searchKey=${keyword}&perPage=${pp}&pageNum=${pageId - 1 || parseInt(endpoint.queryParams.cp) - 1}` + storyType;
        return url;
      } else if (endpoint.queryParams.apiType == 'orian-search') {
        if (typeof props.CONSTANTS.CDS_API !== "undefined") {
          cdsDomain = props.CONSTANTS.CDS_API;
        } else {
          cdsDomain = props.CONSTANTS.API_URL.CDS_API;
        }
        url = `${cdsDomain}/cds-feed-ext/jcms/orion?hostId=${endpoint.queryParams.hostId}&msid=${endpoint.queryParams.msid}&perpage=${pp}`;
        return url;
      }
      if (!isLoadMore) {
        url += `?msid=${endpoint.queryParams.msid}&fv=${endpoint.queryParams.fv}&hostId=${endpoint.queryParams.hostId}&cp=${pageId}&apiType=${endpoint.queryParams.apiType}${endpoint.queryParams.ct ? `&contentType=${endpoint.queryParams.ct}` : ""}&st=${endpoint.queryParams.st}&story=7&so=${endpoint.queryParams.so}${props.title != "Slide Show" ? `&&pp=${pp}` : ""}${props.authorCard ? "&au=1" : ""}`
      } else {
        url += `?msid=${endpoint.queryParams.msid}&fv=${endpoint.queryParams.fv}&hostId=${endpoint.queryParams.hostId}&cp=${pageId}&apiType=${endpoint.queryParams.apiType}${endpoint.queryParams.ct ? `&contentType=${endpoint.queryParams.ct}` : ""}&st=${endpoint.queryParams.st}&so=${endpoint.queryParams.so}&pp=20`
      }
    } else {

      if (!isLoadMore) {
        url += `?msid=${endpoint.queryParams.msid}&source=toi&dm=t&cp=${pageId}&apiType=h&tn=html&onlyItems=4&pp=${pp}`
      } else {
        url += `?msid=${endpoint.queryParams.msid}&source=toi&dm=t&cp=${pageId}&apiType=h&tn=html&onlyItems=4&pp=20`
      }
    }
  }
  return url;
}

function isNumeric(str: any) {
  return !isNaN(str) && !isNaN(parseFloat(str));
}

export function validateAndUpdateLpParam(url: string): string {
  try {
    const parsedUrl = new URL(url);
    const lp = parsedUrl.searchParams.get('lp');
    if (lp !== null) {
      const lpValue = Number(lp);
      if (isNaN(lpValue) || lpValue > 100) {
        parsedUrl.searchParams.set('lp', isNaN(lpValue) ? "1" : "100");
        return parsedUrl.toString();
      }
    }
  } catch (error) {
    console.error("Invalid URL:", error);
  }
  return url;
}

export const GetFallBackImage = () => {

  const context = getGlobalUtilContext();
  console.log("contextttttttt", context);
  if( context && context.hostImageId && context.hostImageId.includes('imagesize=') ) {
    console.log("contexttttttt.hostImageId", context.hostImageId);
    return getImageUrl(getImageId(context.hostImageId), getImageSize(context.hostImageId), 268, 200, null, false, {});
  }
  console.log("contextttttttt nooo");

  return '/stresources/images/placeholder-image.png'
}
// export const GetIconsSprites = () => {
//   return '/stresources/images/iconsSprites.png'
// }
// export const GetIconsSprites = () => {
//   return `${window.location.origin}/stresources/images/iconsSprites.png`;
// }

// useEffect(() => {
//   document.documentElement.style.setProperty(
//     '--backgroundImage',
//     `url(${window.location.origin}/stresources/images/iconsSprites.png)`
//   );
// }, []);

export const GetIconsSprites = () => {
  return 'https://staticimg.publishstory.co/stresources/images/iconsSprites.png'
}

export const GetSpritesIcons = () => {
  return iconsSprites
  // return '/stresources/images/iconsSprites.png'
}
export const isImageSizeBlank = (str: any) => {
  //var imageSizeRegex = /imagesize=\d+/;
  var imageSizeRegex = /(?:imgsize|imagesize)=\d+/;
  return imageSizeRegex.test(str);
}

export const getSocialClassName = (name: string, themeid: number, componentName?: string) => {
  let className = '';
  // console.log('getSocialClassName', getSocialClassName)
  // console.log('getSocialClassName', name, themeid, componentName);
  // Determine the base class based on the platform name
  switch (name) {
    case 'facebookprofilepage':
    case 'Facebook':
      if (themeid === 1 && componentName === 'author') {
        className = 'bg-Facebook_icon_T3';
      } else {
        className = themeid === 1 ? 'bg-Facebook_footer_icon_T1' : (themeid === 2 ? 'bg-Facebook_icon_T2' : 'bg-facebook_footer_icon_T3');

      }
      break;
    case "facebook":
      if (themeid === 1 && componentName === 'author') {
        className = 'bg-Facebook_icon_T3';
      } else {
        className = themeid === 1 ? 'bg-Facebook_footer_icon_T1' : (themeid === 2 ? 'bg-Facebook_icon_T2' : 'bg-facebook_footer_icon_T3');

      }
      break;

    case 'twitterhandle':
    case 'twitter':
      if (themeid === 1 && componentName === 'author') {
        className = 'bg-X_icon_T3';
      } else {
        className = themeid === 1 ? 'bg-X_footer_icon_T1' : (themeid === 2 ? 'bg-X_icon_T2 ' : 'bg-X_footer_icon_T3');

      }
      break;
    case 'instagramurl':
    case 'instagram':
      if (themeid === 1 && componentName === 'author') {
        className = 'bg-Instagram_icon_T3';
      } else {
        className = themeid === 1 ? 'bg-Instagram_footer_icon_T1' : (themeid === 2 ? 'bg-Instagram_icon_T2' : 'bg-Instagram_footer_icon_T3 ');

      }
      break;
    case 'linkedinurl':
    case 'linkedIn':
      // 👇 Apply special override for author.tsx + theme 1
      if (themeid === 1 && componentName === 'author') {
        className = 'bg-in_icon_T3';
      } else {
        className = themeid === 1 ? 'bg-in_footer_icon_T1 ' : (themeid === 2 ? 'bg-in_icon_T2' : 'bg-in_footer_icon_T3');
      }
      break;
    case 'youtubeurl':
    case 'youtube':
      if (themeid === 1 && componentName === 'author') {
        className = 'bg-Youtube_icon_T3';
      } else {
        className = themeid === 1 ? 'bg-youtube_footer_icon_T1' : (themeid === 2 ? 'bg-Youtube_icon_T2' : 'bg-youtube_footer_icon_T3');
      }
      break;
    case 'pinterest':
      if (themeid === 1 && componentName === 'author') {
        className = 'bg-Pinterest_icon_T3';
      } else {
        className = themeid === 1 ? 'bg-pinterest_footer_icon_T1 ' : (themeid === 2 ? 'bg-Pinterest_icon_T2 ' : 'bg-pinterest_footer_icon_T3');

      }
      break;
    case 'playstore':
      if (themeid === 1 && componentName === 'author') {
        className = 'bg-google_play_icon_T1';
      } else {
        className = themeid === 1 ? 'bg-google_play_footer_icon_T1' : (themeid === 2 ? 'bg-google-play_icon_T2' : 'bg-google_play_footer_icon_T3');

      }
      break;
    case 'whatsapp':
      if (themeid === 1 && componentName === 'author') {
        className = 'bg-Whatsapp_icon_T3';
      } else {
        className = themeid === 1 ? 'bg-Whatsapp_footer_icon_T3' : (themeid === 2 ? 'bg-Whatsapp_icon_T2' : 'bg-Whatsapp_footer_icon_T3');

      }
      break;
    // case 'snapchaturl':
    //   {
    //     className = themeid === 1 ? 'bg-snapchat_mono' : (themeid === 2 ? 'bg-snapchat_circle' : 'bg-snapchat_mono');
    //     break;
    //   }
    // case 'flicker':
    // case 'Flickr':
    //   {
    //     className = themeid === 1 ? 'bg-flickr_mono' : (themeid === 2 ? 'bg-flickr_circle' : 'bg-flickr_mono');
    //     break;
    //   }
    // case 'Google':
    //   {
    //     className = themeid === 1 ? 'bg-google_mono' : (themeid === 2 ? 'bg-google_circle' : 'bg-google_mono');
    //     break;
    //   }

    // case 'Amazon':
    //   {
    //     className = themeid === 1 ? 'bg-amazon_mono' : (themeid === 2 ? 'bg-amazon_circle' : 'bg-amazon_mono');
    //     break;
    //   }
    // case 'Microsoft':
    //   {
    //     className = themeid === 1 ? 'bg-microsoft_mono' : (themeid === 2 ? 'bg-microsoft_circle' : 'bg-microsoft_mono');
    //     break;
    //   }

    // Add other social platforms if needed
    default:
      className = 'bg-iconb'; // Default class if no match
  }

  return className;
};



export const convertEpochTime = (epochTimestamp: any, publishedOrUpdated: any, dateTimeFormat: any) => {
  let formattedDateTime;
  let prefix;
  const date = new Date(+epochTimestamp);
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  if (publishedOrUpdated === 'published') {
    prefix = '';
  } else {
    prefix = '';
  }
  const month = months[date.getMonth()];
  var day = date.getDate().toString().padStart(2, '0');
  var dayName = days[date.getDay()];
  var year = date.getFullYear();
  var hour = date.getHours().toString().padStart(2, '0');
  var minute = date.getMinutes().toString().padStart(2, '0');

  if (dateTimeFormat === 'MMM DD, YYYY, HH:MM TZ') {
    formattedDateTime = `${prefix} ${month} ${day}, ${year}, ${hour}:${minute} IST`;
  } else if (dateTimeFormat === 'DD MMM YYYY, HH:MM TZ') {
    formattedDateTime = `${prefix} ${day} ${month} ${year}, ${hour}:${minute} IST`;
  } else if (dayName) {
    formattedDateTime = `${dayName.substring(0, 3)}, ${day} ${month} ${year}`;
  }

  return formattedDateTime;
}



//This will return Author data along with its source URLs.
export const showMultipleAuthor = (authorData: any, baseDomain: any) => {
  if (authorData && authorData.length > 0) {
    let multipleAuthor = '';
    if (authorData.length == 1) {
      return `<a href=${createAuthorLink(baseDomain, authorData[0])} target="_self"> ${authorData[0].name}</a>`;
    }
    if (authorData.length == 2) {
      return `<a href=${createAuthorLink(baseDomain, authorData[0])} target="_self"> ${authorData[0].name}</a> & <a href=${createAuthorLink(baseDomain, authorData[1])} target="_self"> ${authorData[1].name}</a></>`;
    }
    for (let index = 0; index < authorData.length - 1; index++) {
      multipleAuthor += `<a href=${createAuthorLink(baseDomain, authorData[index])} target="_self"> ${authorData[index].name}</a>` + ', ';
    }
    multipleAuthor = multipleAuthor.substring(0, multipleAuthor.length - 2) + ' & ' + `<a href=${createAuthorLink(baseDomain, authorData[authorData.length - 1])} target="_self"> ${authorData[authorData.length - 1].name}</a>`;
    return multipleAuthor;
  } else {
    return '';
  }
}
export const createAuthorLink = (baseDomain: any, authorData: any) => {
  // let slash = '/';
  // if (baseDomain && baseDomain.charAt(baseDomain.length - 1) === '/') {
  //   slash = '';
  // }

  const authorLink = `/<seo-name>/author/<author-id>.html`;
  if (authorData)
    return authorData && authorLink.replace('<seo-name>', authorData.seoname).replace('<author-id>', authorData.id);
}

export const getImageUrl = (imageId: any, imageSize: any, width: any, height: any = undefined, baseDomain: any, isAuthorImage: any = false, constants: any, resizemode: string = "4"): string => {
  // console.log( "getImageUrl", imageId, imageSize, width, height );
  let url = "";

  // console.log("constants.VSP_IMAGES :::::::::  " +  constants.VSP_IMAGES);

  if (!isAuthorImage) {
    if (imageId && imageSize && width && height) {
      url = `${constants?.VSP_IMAGES ? constants?.VSP_IMAGES : ''}/thumb/${imageId}.cms?imgsize=${imageSize}&width=${width}&height=${height}&resizemode=${resizemode}`;
    } else if (imageId && imageSize && width && (height == undefined || !height)) {
      url = `${constants?.VSP_IMAGES ? constants?.VSP_IMAGES : ''}/thumb/${imageId}.cms?imgsize=${imageSize}&width=${width}&resizemode=${resizemode}`;
    } else if (imageId && width) {
      url = `${constants?.VSP_IMAGES ? constants?.VSP_IMAGES : ''}/thumb/${imageId}.cms?width=${width}&resizemode=${resizemode}`;
    }
  } else {
    if (imageId && imageSize && width && height) {
      url = `${constants?.VSP_IMAGES ? constants?.VSP_IMAGES : ''}/authorthumb/${imageId}.cms?imgsize=${imageSize}&width=${width}&height=${height}&resizemode=${resizemode}`;
    } else {
      url = `${constants?.VSP_IMAGES ? constants?.VSP_IMAGES : ''}/authorthumb/${imageId}.cms?imgsize=${imageSize}&width=${width}&height&resizemode=${resizemode}`;
    }
  }

  if (!(url.includes("http://") || url.includes("https://"))) {
    url = "/" + url.replace(/^\/|\/$/g, '');
    if (typeof window !== 'undefined' && undefined !== window && window
      && PAGEBUILDER_URLS.some(domain => window.location.origin.includes(domain))) {
      url = "https://staticimg.publishstory.co" + url;
    }
  }
  else if (!(typeof window !== 'undefined' && undefined !== window && window)) {
    if (url.includes(".com")) {
      url = "/" + url.split(".com/")[1];
    } else if (url.includes(".co/")) {
      url = "/" + url.split(".co/")[1];
    }
  }
  else if (typeof window !== 'undefined' && undefined !== window && window
    && !PAGEBUILDER_URLS.some(domain => window.location.origin.includes(domain))) {

    if (url.includes(".com")) {
      url = "/" + url.split(".com/")[1];
    } else if (url.includes(".co/")) {
      url = "/" + url.split(".co/")[1];
    }
  }

  if (imageSize && (imageSize == 0 || imageSize == '0')) {

    const context = getGlobalUtilContext();
    console.log("ccontexttttt", imageId, context);
    if( context && context.hostImageId && context.hostImageId.includes('imagesize=') && imageId != getImageId(context.hostImageId) ) {
      console.log("ccontexttttt.hostImageId", imageId, context.hostImageId);
      return getImageUrl(getImageId(context.hostImageId), getImageSize(context.hostImageId), width, height, baseDomain, isAuthorImage, constants, resizemode);
    }
    console.log("ccontexttttt.imageId", imageId);

    return '/stresources/images/placeholder-image.png';
  }

  console.log("ccontexttttt url", url);

  return url;
}

export const getImageId = (imageId: any) => {
  if (!imageId) {
    return '';
  }
  return imageId.substring(0, imageId.indexOf('&'));
}

export const getImageSize = (imageId: any) => {
  if (!imageId) {
    return '';
  }
  let imageIdVal = imageId.indexOf("imagesize=") > 0 ? imageId.split("imagesize=") : imageId.split('imgsize=');
  return imageIdVal.length > 0 && imageIdVal[1] != "0" ? imageIdVal[1] : '';
}




function getMediaIdFromCmsembeds(msid: string, cmsembeds: any[]): string | null {
  for (let item of cmsembeds) {
    if (item.msid === msid && item.cmstype === "MEDIAVIDEO") {
      return item.media.id;
    }
  }
  return null; // Return null if no match found
}

// const loadScriptToHead = (scriptContent: string,slotNumber: number): Promise<void> => {
//   return new Promise((resolve, reject) => {
//     try {
//       if (typeof document === 'undefined') {
//         resolve();
//         return;
//       }

//       // First ensure GPT script is loaded
//       if (!document.querySelector('script[src*="securepubads.g.doubleclick.net"]')) {
//         const gptScript = document.createElement('script');
//         gptScript.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
//         gptScript.async = true;
//         document.head.appendChild(gptScript);
//       }

//       // Extract the ad definition script from headScript
//       const div = document.createElement('div');
//       div.innerHTML = scriptContent;
//       const scriptTags = div.getElementsByTagName('script');

//       // Find the script that contains the ad definition
//       const adScript = Array.from(scriptTags).find(script => 
//         script.innerHTML.includes('defineSlot') && 
//         !script.src.includes('securepubads.g.doubleclick.net')
//       );

//       if (adScript && adScript.innerHTML) {
//         // Execute the ad definition script in googletag.cmd
//         window.googletag.cmd.push(() => {
//           try {
//             eval(adScript.innerHTML);
//             console.log(`Ad slot ${slotNumber} defined successfully`);
//             resolve();
//           } catch (error) {
//             console.error('Error executing ad script:', error);
//             reject(error);
//           }
//         });
//       } else {
//         console.error('No valid ad definition script found');
//         reject(new Error('No valid ad definition script found'));
//       }
//     } catch (error) {
//       console.error('Script processing error:', error);
//       reject(error);
//     }
//   });
// };
const AdSlotComponent: FC<AdSlotProps> = ({ headScript, bodyScript, slotNumber, adSize, componentName }) => {
  const [isReady, setIsReady] = useState(false);
  const isMountedRef = useRef(true);

  const addName = `${componentName.toLowerCase().replace(/\s+/g, "_")}_ad_slot_${slotNumber}`;

  useEffect(() => {

    console.log("Inside useEffect of AdSlotComponent");
    isMountedRef.current = true;

    const isGoogleAd = headScript.includes("securepubads.g.doubleclick.net");
    const isColombiaAd = headScript.includes("static.clmbtech.com");
    const isMgidAd = headScript.includes("jsc.mgid.com");
    // const isAmpAd = headScript.includes("cdn.ampproject.org");

    // console.log("isAmpAd ::: ", isAmpAd);

    // if (isAmpAd) {

    //   console.log("Detected AMP Ad");

    //   console.log(`[Ad ${addName}] Loading AMP Ad`);
    //   const tempDiv = document.createElement("div");
    //   tempDiv.innerHTML = headScript;
    //   const scripts = Array.from(tempDiv.getElementsByTagName("script"));

    //   scripts.forEach(scriptElement => {
    //     // Skip if script already exists
    //     const customElement = scriptElement.getAttribute('custom-element');
    //     const src = scriptElement.getAttribute('src');
    //     if (customElement && src && src.includes('ampproject.org')) {
    //       const existingScript = document.querySelector(
    //         `script[custom-element="${customElement}"][src*="ampproject.org"]`
    //       );
    //       if (existingScript) {
    //         return;
    //       }
    //     }

    //     const script = document.createElement("script");
    //     script.async = true;
    //     if (scriptElement.src) {
    //       script.src = scriptElement.src;
    //     }
    //     if (customElement) {
    //       script.setAttribute('custom-element', customElement);
    //     }
    //     document.head.appendChild(script);
    //   });

    //   setIsReady(true);
    // }

    if (isGoogleAd) {
      console.log(`[Ad ${addName}] Loading Google Ad`);
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = headScript;
      const scripts = Array.from(tempDiv.getElementsByTagName("script"));

      scripts.forEach(scriptElement => {
        const script = document.createElement("script");
        // Skip adding GPT script if it already exists
        if (scriptElement.src && scriptElement.src.includes("securepubads.g.doubleclick.net/tag/js/gpt.js")) {
          if (document.querySelector('script[src*="securepubads.g.doubleclick.net/tag/js/gpt.js"]')) {
            return;
          }
        }

        if (scriptElement.src) {
          script.src = scriptElement.src;
          script.async = true;
        } else {
          script.innerHTML = scriptElement.innerHTML;
        }
        document.head.appendChild(script);
      });

      // Extract and execute body script for Google Ads
      const bodyDiv = document.createElement("div");
      bodyDiv.innerHTML = bodyScript;
      const bodyScriptElement = bodyDiv.querySelector("script");
      if (bodyScriptElement && window.googletag) {
        window.googletag.cmd.push(() => {
          try {
            eval(bodyScriptElement.innerHTML);
            // console.log(`[Ad ${addName}] Google Ad body script executed`);
          } catch (error) {
            console.error(`[Ad ${addName}] Error executing Google Ad body script:`, error);
          }
        });
      }

      setIsReady(true);
    }

    if (isColombiaAd) {
      console.log(`[Ad ${addName}] Loading Colombia Ad`);
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = headScript;
      const scriptElement = tempDiv.querySelector("script");

      if (scriptElement) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.innerHTML = scriptElement.innerHTML;
        document.head.appendChild(script);
      }

      setIsReady(true);
    }

    if (isMgidAd) {
      console.log(`[Ad ${addName}] Loading MGID Ad`);
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = headScript;
      const scriptElement = tempDiv.querySelector("script");

      if (scriptElement) {
        const script = document.createElement("script");
        script.src = scriptElement.src;
        script.async = true;
        document.head.appendChild(script);
      }

      setIsReady(true);
    }

    return () => {
      isMountedRef.current = false;
    };
  }, [headScript, bodyScript, slotNumber]);

  console.log("returning from ad slot component", bodyScript);

  if(componentName === "BellyAmp") {
    console.log("Inside BellyAmp Pages adslot div", componentName);

    return (
      <div
        id={`${componentName.toLowerCase().replace(/\s+/g, "_")}_ad_slot_${slotNumber}`}
        style={{
          textAlign: "center",
          margin: "0 auto",
          // maxHeight: adSize?.split("*")?.[1] ? adSize.split("*")[1] + "px" : "auto",
          // display: "flex",
          // justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          backgroundColor: !isReady ? "transparent" : "transparent",
          paddingTop: "10px",
          paddingBottom: "10px"
        }}
        dangerouslySetInnerHTML={{ __html: bodyScript }}
      />
    );
  }
  else if(componentName === "Belly") {
    console.log("Inside Belly Pages adslot div", componentName);

    return (
      <div
        id={`${componentName.toLowerCase().replace(/\s+/g, "_")}_ad_slot_${slotNumber}`}
        style={{
          textAlign: "center",
          margin: "0 auto",
          // maxHeight: adSize?.split("*")?.[1] ? adSize.split("*")[1] + "px" : "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          overflow: "hidden",
          backgroundColor: !isReady ? "transparent" : "transparent",
          paddingTop: "10px",
          paddingBottom: "10px"
        }}
        dangerouslySetInnerHTML={{ __html: bodyScript }}
      />
    );
  }

  else if(["Ad Scripts Amp", "Ad Scripts Two Amp", "Ad Scripts Three Amp"].includes(componentName)) {

    console.log("Inside AMP Pages adslot div", componentName);

    return (
      <div
        id={`${componentName.toLowerCase().replace(/\s+/g, "_")}_ad_slot_${slotNumber}`}
        style={{
          textAlign: "center",
          margin: "0 auto",
          // maxHeight: adSize?.split("*")?.[1] ? adSize.split("*")[1] + "px" : "auto",
          // display: "flex",
          // justifyContent: "center",
          alignItems: "center",
          // overflow: "hidden",
          backgroundColor: !isReady ? "transparent" : "transparent",
          paddingTop: "10px",
          paddingBottom: "10px"
        }}
        dangerouslySetInnerHTML={{ __html: bodyScript }}
      />
    );

  } else {

    console.log("Inside fallback Pages adslot div", componentName);
    return (
      <div
        id={`${componentName.toLowerCase().replace(/\s+/g, "_")}_ad_slot_${slotNumber}`}
        style={{
          textAlign: "center",
          margin: "0 auto",
          // maxHeight: adSize?.split("*")?.[1] ? adSize.split("*")[1] + "px" : "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // overflow: "hidden",
          backgroundColor: !isReady ? "transparent" : "transparent",
          paddingTop: "10px",
          paddingBottom: "10px"
        }}
        dangerouslySetInnerHTML={{ __html: bodyScript }}
      />
    );
  }
};

declare global {
  interface Window {
    googletag: any;
  }
}
interface RelatedStory {
    hl: string;
    wu: string;
    // add other properties if needed
}

export const processArticleBody_New = (articleBody: any, embeds: any, baseDomain: any, constant: any, bodySnippet: any, adSize: any, clientHostId: any, channelName?: any, showImageCredits: boolean = false, relatedStories: any = [], showRelatedStories: boolean = false, starKeyword: string = "", relatedStoriesLable: string = "More stories on") => {
  // console.log('articleBody', articleBody); 
  // console.log('articleBody.highlights', articleBody.highlights); 
  //console.log('bodySnippet 6789', bodySnippet);
  // Define the ref at the component level
  //const foundObject = embeds.find((item: any) => item.msid == 111679259);
  //console.log('embed article', foundObject)

  try {
    if (typeof articleBody !== 'undefined' && typeof articleBody === 'object' && articleBody !== null) {
      let counter = 0;
      let paragraphCounter = 0;
      let isBold = false;
      let isU = false;
      let isEm = false;
      let currentListItems: any[] = [];
      let insideLI = false;
      let liBuffer: any[] = [];
      let adSlotCounter = 1;
      let isSup = false;
      let isSub = false;

        const wrapContentWithTags = (content: any, index: number) => {
        let wrappedContent = content;

        if (isSup) {
          wrappedContent = <sup key={`sup-wrap-${index}`}>{wrappedContent}</sup>;
        }
        if (isSub) {
          wrappedContent = <sub key={`sub-wrap-${index}`}>{wrappedContent}</sub>;
        }
        if (isU) {
          wrappedContent = <u key={`u-wrap-${index}`}>{wrappedContent}</u>;
        }
        if (isEm) {
          wrappedContent = <i key={`em-wrap-${index}`}>{wrappedContent}</i>;
        }
        if (isBold) {
          wrappedContent = <strong key={`strong-wrap-${index}`}>{wrappedContent}</strong>;
        }
        return wrappedContent;
      };
      const parsedContent = articleBody.map((node: any, index: number) => {
        if (node && node.tags) {
          if (node.tags === "strong_open") {
            isBold = true;
            return null; // Consume the open tag
          } else if (node.tags === "strong_close") {
            isBold = false;
            return null; // Consume the close tag
          }
          if (node.tags === "u_open") {
            isU = true;
            return null;
          } else if (node.tags === "u_close") {
            isU = false;
            return null;
          }
          if (node.tags === "em_open") {
            isEm = true;
            return null;
          } else if (node.tags === "em_close") {
            isEm = false;
            return null;
          }else if (node.tags === "ul_close") {
            const ul = <ul key={`ul-${index}`}>{currentListItems}</ul>;
            currentListItems = [];
            return ul;
          }
          if (node.tags === "ol_open") {
            currentListItems = [];
            return null;
          } else if (node.tags === "ol_close") {
            const ol = <ol key={`ol-${index}`}>{currentListItems}</ol>;
            currentListItems = [];
            return ol;
          }if (node.tags === "li_open") {
            insideLI = true;
            liBuffer = [];
            return null;
          } else if (node.tags === "li_close") {
            insideLI = false;
            const li = <li key={`li-${index}`}>{liBuffer}</li>;
            currentListItems.push(li);
            liBuffer = [];
            return null;
          }if (node.tags === "sup") {
            isSup = !isSup;
          }
          if (node.tags === "sub") {
            isSub = !isSub;
          }
          
        }
        // --- START: HIGHLIGHTED CHANGE (Consolidated Text and Link Handling) ---
        if (node.type === 'text' && node.value) {
          const content = wrapContentWithTags(node.value, index);
          if (insideLI) {
            liBuffer.push(<React.Fragment key={index}>{content}</React.Fragment>);
            return null;
          } else {
            return <React.Fragment key={index}>{content}</React.Fragment>;
          }
        }

        if (node.type === "link" && node.value) {
          const linkContent = (
            <a key={`link-${index}`} href={node.wu} target="_self">
              {node.value}
            </a>
          );
          const wrappedLink = wrapContentWithTags(linkContent, index);
          if (insideLI) {
            liBuffer.push(<React.Fragment key={index}>{wrappedLink}</React.Fragment>);
            return null;
          }
          return wrappedLink;
        }
        // --- END: HIGHLIGHTED CHANGE ---

        // Render text nodes with dynamically nested tags
        if (node.type === 'text' && node.value) {
          let content = node.value;
          //console.log("PWD", content)
          // console.log("tagofnode", node.tags)

          // Wrap the content with tags based on the current state
          if (isU) {
            content = <u key={`u-${index}`}>{content}</u>;
          }
          if (isEm) {
            content = <i key={`i-${index}`}>{content}</i>;
          }
          if (isBold) {
            content = <strong key={`strong-${index}`}>{content}</strong>;
          }
          if (isSup) {
            content = <sup key={`sup-${index}`}>{content}</sup>;
          }
          if (isSub) {
            content = <sub key={`sub-${index}`}>{content}</sub>;
          }
          if (insideLI) {
            liBuffer.push(<React.Fragment key={index}>{content}</React.Fragment>);
            return null;
          } else {
            return <React.Fragment key={index}>{content}</React.Fragment>;
          }

          // return <React.Fragment key={index}>{content}</React.Fragment>;
        }


        if (node.type === "text" && !isBold && !isU && !isEm) {
          return <span style={{ fontWeight: 'normal' }} key={index}>{node.value}</span>;
        }

        else if (node.type === "br") {
          if (insideLI) {
            liBuffer.push(<br key={index} />);
            return null;
          }
          const adElement: any[] = [];
          counter = counter + 1;
          paragraphCounter += 1;
         
          if (counter === 2 && bodySnippet !== undefined && bodySnippet !== null && bodySnippet !== "") {
            counter = 0; // Reset br counter
            const deviceAds = isDesktop ? bodySnippet.desktop : bodySnippet.mobile;
            
            // Only insert ad if we haven't exceeded the number of available ads
            if (deviceAds && deviceAds.length > 0) {
              deviceAds.forEach((ad: any, adindex: number) => {
                if (ad.paragraphOffset && String(ad.paragraphOffset) === String(adSlotCounter)) {
                  adElement.push(React.createElement(AdSlotComponent, {
                    key: `${index}-${adindex}`,
                    headScript: ad.headScript,
                    bodyScript: ad.bodyScript,
                    slotNumber: adindex,
                    adSize: adSize,
                    componentName: "Belly"
                  }));
                }
              });

            }
            adSlotCounter++;
          }
          
          if(paragraphCounter == 6 && showRelatedStories && Array.isArray(relatedStories) && relatedStories.length > 0 && starKeyword) {
            adElement.push(
                    <div className='relatedStoriesWrapper'>
                        <p className='articleRelatedStories'>{relatedStoriesLable} {starKeyword}</p>
                        <ul>
                            {relatedStories.slice(0, 5).map((story: RelatedStory, index: number) => (
                                <li key={index}> <a href={story.wu} target="_blank" rel="noopener noreferrer">{story.hl}</a></li>
                            ))}
                        </ul>
                    </div>
                );
            showRelatedStories = false;
          }

          if(adElement.length === 0){adElement.push(<br key={index} />);}

          return adElement;
        }

        else if (node.type === "keyword") {
          return (<span></span>);
        }
        // else if (node.type === "text" && node.tags == "strong") {
        //   return (<strong key={index}>{node.value}</strong>);
        // }
        // else if (node.type === "text" && node.tags == "span") {
        //   return (<span key={index}>{node.value}</span>);
        // }
        // else if (node.type === "text" && node.tags == "u") {
        //   return (<u key={index}>{node.value}</u>);
        // }
        // else if (node.type === "text" && node.tags == "em") {
        //   return (<i key={index}>{node.value}</i>);
        // }
        else if (node.type === "text" && node.tags == "p") {
          return (<p key={index}>{node.value}</p>);
        }
        else if (node.type === "text" && node.tags == "ul") {
          return (<ul key={index}>{node.value}</ul>);
        }
        else if (node.type === "text" && node.tags == "li") {
          return (<li key={index}>{node.value}</li>);
        }
        else if (node.type == "sup") {
          return (<sup key={index}>{node.value}</sup>);
        }
        // else if (node.type === "text" && isBold && node.value) {
        //   return (<strong key={index}>{node.value}</strong>);
        // }
        // else if (node.type === "text" && isU && node.value) {
        //   return (<u key={index}>{node.value}</u>);
        // }
        // else if (node.type === "text" && isEm && node.value) {
        //   return (<i key={index}>{node.value}</i>);
        // }
        else if (node.tags == "p_open") {
          return ('');
        }
        else if (node.tags == "p_close") {
          return (<div className='ptagspace' key={index} />);
        }
        // else if (node.type == "link") {
        //   return (<a key={index} href={node.wu} target="_self">{node.value}</a>);
        // }
        else if (node.type === "link") {
          const linkElement = (
            <a key={`link-${index}`} href={node.wu} target="_self">
              {node.value}
            </a>
          );
          if (insideLI) {
            liBuffer.push(linkElement);
            return null;
          }
          return linkElement;
        }
        else if (node.type == "wikipedia") {
          return <iframe
            src={node.url}
            width="100%"
            height="400"
            style={{ border: 'none' }}
            allowFullScreen>
          </iframe>
          return null
        }
        else if (node.type == "ExtQuote") {
          return (<div className='CommonEmbedQuoteWrapper'>
            <span className='CommonEmbedQuotesIcon'><svg width="32" height="26" viewBox="0 0 32 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.698242 25.4639V19.2012C0.698242 17.0964 1.04329 14.9053 1.7334 12.6279C2.45801 10.3161 3.49316 8.10775 4.83887 6.00293C6.18457 3.86361 7.80632 2.01758 9.7041 0.464844L15.1387 4.24316C13.5514 6.52051 12.3265 8.86686 11.4639 11.2822C10.6012 13.6631 10.1699 16.251 10.1699 19.0459V25.4639H0.698242ZM17.002 25.4639V19.2012C17.002 17.0964 17.347 14.9053 18.0371 12.6279C18.7617 10.3161 19.7969 8.10775 21.1426 6.00293C22.4883 3.86361 24.11 2.01758 26.0078 0.464844L31.4424 4.24316C29.8551 6.52051 28.6302 8.86686 27.7676 11.2822C26.9049 13.6631 26.4736 16.251 26.4736 19.0459V25.4639H17.002Z" fill="black" />
            </svg>
            </span><div className='CommonEmbedQuoteSummery'>{node.value}</div><div className='CommonEmbedQuoteAuthor'>By: {node.au}</div></div>)
        }
        else if (node.type == "Article") {
          const articleObject = embeds && embeds.find((item: any) => item.msid == node.msid);
          if (!articleObject) {
            return null;
          }
          let imageUrl = getImageUrl(articleObject?.msid, articleObject?.thumbsize, '90', '120', baseDomain, false, constant);
          return (
            <div key={index} className='CommonEmbedArtileShowWrapper'>
              <a href={`/${articleObject?.seopath}/articleshow/${articleObject?.msid}.html`}>
                <div className='CommonEmbedArtileShow'>
                  <div className='CommonEmbedArtileImageWrap'><img height="120" width="90" src={imageUrl} /></div>
                  <div className='CommonEmbedArtileContentWrap'>
                    <span className='CommonEmbedArtileTitle'>{articleObject?.title}</span>
                    <div className='CommonEmbedSurveyQuizTimeWrap'>
                                        {/* <div className='CommonEmbedSurveyQuizTimeWrap'>{convertEpochTime(articleObject.updatedate, "", "DD MMM YYYY")} , <div className='CommonEmbedSurveyQuizAuthorName'><span className='AuthorsCommonBy'>By</span> <span className='AuthorwrapCommon'>{articleObject.authors[0].name}</span></div></div> */}
                      {articleObject.updatedate && convertEpochTime(articleObject.updatedate, "", "DD MMM YYYY")}
                      {articleObject.updatedate && articleObject.authors && articleObject.authors.length > 0 && ' , '}
                      {articleObject.authors && articleObject.authors.length > 0 && <div className='CommonEmbedSurveyQuizAuthorName'><span className='AuthorsCommonBy'>By</span> <span className='AuthorwrapCommon'>{articleObject.authors[0].name}</span></div>}
                    </div>
                    <div className='CommonEmbedSurveyQuizSynopsis CommonEmbedSurveyQuizSynopsisDesktop'>{articleObject?.synopsis}</div>
                  </div>
                </div>
                <div className='CommonEmbedSurveyQuizSynopsis CommonEmbedSurveyQuizSynopsisMobile'>{articleObject?.synopsis}</div>
              </a>
            </div>
          )
        }
        else if (node.type == "document" && node.subType == "pdf") {
          const downloadObject = embeds && embeds.find((item: any) => item.msid == node.msid);
          let imageUrl = getImageUrl(downloadObject?.msid, downloadObject?.thumbsize, '90', '120', baseDomain, false, constant);
          return (<div className='CommonEmbedFileDownload'><a href={imageUrl}>{node.value}</a>
            {/* <FrontAwesomeIcon icon={faFilePdf} size="2x" color="red" /> */}
            <div className='bg-PDF_icon_embed' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
          </div>)
        }
        else if ((node.type == "SURVEY" && node.subType == "1") || (node.type == "QUIZ" && node.subType == "1")) {
          const mcqObject = embeds && embeds.find((item: any) => item.msid == node.msid);
          // let imageUrl = getImageUrl(mcqObject?.msid, mcqObject?.thumbsize, '90', '120', baseDomain, false, constant);
          return (
            <div key={index} className='CommonEmbedQuizSurveyShowWrapper'>
              <a href={`/${mcqObject?.seopath}/${node.type == "SURVEY" ? 'surveyshow' : 'quizshow'}/${mcqObject?.msid}.html`}>
                <div className='CommonEmbedQuizSurveyShow'>
                  {/* <h1>{node.type == "SURVEY" ? 'SURVEY' : 'QUIZ'}</h1> */}
                  {/* <img height="120" width="90" src={imageUrl} style={{ width: '120px', height: '90px', float: 'left' }} /> */}
                  <span className='CommonEmbedSurveyQuizTitle' dangerouslySetInnerHTML={{ __html: mcqObject?.title }}></span>
                  <div className='CommonEmbedSurveyQuizTimeWrap'>{convertEpochTime(mcqObject?.updatedate, "", "DD MMM YYYY")} , <div className='CommonEmbedSurveyQuizAuthorName'><span className='AuthorsCommonBy'>By</span> <span className='AuthorwrapCommon'>{mcqObject && mcqObject?.authors && mcqObject?.authors[0]?.name || ''}</span></div></div>
                  <span className='CommonEmbedSurveyQuizSynopsis' dangerouslySetInnerHTML={{ __html: mcqObject?.synopsis }}></span>
                  {/* <div className='CommonEmbedSurveyButton'><button>Start Survey</button></div> */}
                  <div className='CommonEmbedSurveyButton'><button>{node.type == "SURVEY" ? "Start Survey" : "Start Quiz"}</button></div>
                </div>
              </a>
            </div>
          )
        }
        else if (node.type === "Poll") {
          const pollObject = embeds && embeds.find((item: any) => item.msid == node.msid);
          return <EmbedPoll pollObject={pollObject}
            baseDomain={baseDomain}
            constants={constant} />
        } 

        else if (node.type === "cdata") {
          // This handles cdata nodes that are part of a list item.
          // If insideLI is true, it means the cdata is part of an inline flow within an LI.
          if (insideLI) {
              const wrappedCdata = wrapContentWithTags(
                  <span dangerouslySetInnerHTML={{ __html: node.value }} />,
                  index
              );
              liBuffer.push(<React.Fragment key={`cdata-li-${index}`}>{wrappedCdata}</React.Fragment>);
              return null;
          }

          // These handle specific cdata subtypes that require block-level rendering (e.g., Instagram embeds, Twitter embeds)
          if (node.subType === "Custom" || node.subType === "Instagram" || node.subType === "Reels-Instagram" || node.subType === "twitter") {
              // ... (Existing block-level rendering logic for these specific subtypes)
              // (No change needed here, as these are correctly rendered as block elements)
              if (node.subType === "Custom") {
                  const sanitizedValue = node.value.replace(/ contenteditable="false"/g, '');
                  return (
                      <div key={index} className='CommonEmbedInstaCustom'>
                          <blockquote
                              className="instagram-media"
                              dangerouslySetInnerHTML={{ __html: sanitizedValue }}
                          />
                      </div>
                  );
              } else if (node.subType === "Instagram" || node.subType === "Reels-Instagram") {

                  return (
                    <div key={index} className='CommonEmbedInsta'>
                      <blockquote
                        className="instagram-media"
                        dangerouslySetInnerHTML={{ __html: node.value }}
                      />
                    </div>
                  );

                  // const permalinkMatch = node.value.match(/data-instgrm-permalink="([^"]+)"/);
                  // const instagramUrl = permalinkMatch ? permalinkMatch[1] : null;

                  // if (instagramUrl) {
                  //     const instagramIdMatch = instagramUrl.match(/(?:reel|p)\/([a-zA-Z0-9_-]+)/);
                  //     const instagramId = instagramIdMatch ? instagramIdMatch[1] : null;

                  //     if (instagramId) {
                  //         return (
                  //             <div key={index} className='CommonEmbedInsta'>
                  //                 <iframe
                  //                     src={`https://www.instagram.com/p/${instagramId}/embed/`}
                  //                     width="100%"
                  //                     height="auto"
                  //                     frameBorder="0"
                  //                     scrolling="no"
                  //                     allowTransparency={true}
                  //                     allowFullScreen={true}
                  //                     title="Instagram Post"
                  //                     style={{ border: 'none', overflow: 'hidden' }}
                  //                 />
                  //             </div>
                  //         );
                  //     }
                  // }
                  // return null;
              } else if (node.subType === "twitter") {
                  const sanitizedValue = node.value.replace(/ contenteditable="false"/g, '');
                  return (
                      <div key={index} className='CommonEmbedTwitter'>
                          <div dangerouslySetInnerHTML={{ __html: sanitizedValue }}></div>
                      </div>
                  );
              }
          }
          else { 
              // Check if the cdata content contains any common HTML block-level tags.
              // This is the core logic to decide between inline (<span>) and block (<div>) rendering.
              const hasBlockTags = /<(div|p|h[1-6]|ul|ol|li|table|blockquote|address|article|aside|details|figcaption|figure|footer|header|main|nav|section|pre|hr|dl|form|fieldset|menu)\b/i.test(node.value);

              const sanitizedValue = node.value.replace(/ contenteditable="false"/g, '');

              if (hasBlockTags) {
                  // If block-level tags are found, render as a div (default block element behavior).
                  // This covers cases like embedded lists or tables that come as cdata.
                  const classMapping: { [key: string]: string } = {
                      '<ul>': 'list-ul-class',
                      '<ol>': 'list-ol-class',
                      '<table>': 'list-table-class',
                  };
                  const tag = Object.keys(classMapping).find((key) => node.value.startsWith(key));
                  const className = tag ? classMapping[tag] : 'custon-default-class';
                  return (
                      <div className={className} key={index} dangerouslySetInnerHTML={{ __html: sanitizedValue }}></div>
                  );
              } else {
                  // If no block-level tags are found, render as a span (inline element).
                  // This is the fix for "<b>Won by India Women:</b>" and similar cases.
                  return (
                      <span key={index} dangerouslySetInnerHTML={{ __html: sanitizedValue }}></span>
                  );
              }
          }
      }
          


        // else if (node.type === "cdata") {
        //   if (insideLI) {
        //     liBuffer.push(<span key={`cdata-${index}`} dangerouslySetInnerHTML={{ __html: node.value }} />);
        //     return null;
        //   }

        //   if (node.subType === "Custom") {
        //     return (
        //       <div key={index} className='CommonEmbedInstaCustom'>
        //         <blockquote
        //           className="instagram-media"
        //           dangerouslySetInnerHTML={{ __html: node.value }}
        //         />
        //       </div>
        //     );
        //   }
        //   else {
        //     return (
        //       <div key={index} dangerouslySetInnerHTML={{ __html: node.value }}></div>
        //     );
        //   }
        // }
        // else if (node.type === "cdata" && (node.subType === "Instagram" || node.subType === "Reels-Instagram")) {
        //   return (
        //     <div key={index} className='CommonEmbedInsta'>
        //       <blockquote
        //         className="instagram-media"
        //         dangerouslySetInnerHTML={{ __html: node.value }}
        //       />
        //     </div>
        //   );
        // }
        // else if (node.type === "cdata" && Array.isArray(node.scripts) && node.scripts && node.scripts.length === 0) {
        //   const classMapping: { [key: string]: string } = {
        //     '<ul>': 'list-ul-class',
        //     '<ol>': 'list-ol-class',
        //     '<table>': 'list-table-class',
        //   };
        //   const tag = Object.keys(classMapping).find((key) => node.value.startsWith(key));
        //   const className = tag ? classMapping[tag] : 'custon-default-class';

        //   return (
        //     <div className={className} key={index} dangerouslySetInnerHTML={{ __html: node.value }}></div>
        //   );
        // }

        else if (node.type === "sup") {
          return (
            <span key={index} dangerouslySetInnerHTML={{ __html: node.value }}></span>
          );
        }
        else if (node.type === 'inlinevideo') {
          // Convert node.id to a number
          const nodeIdAsNumber = Number(node.id);
          const foundObject = !isNaN(nodeIdAsNumber)
            ? embeds.find((item: any) => item.msid == nodeIdAsNumber)
            : null;

          // Determine the slikeID based on playerType
          const slikeID = (() => {
            if (node.playerType === 'slike') {
              return isNaN(node.id) ? node.id : node.playerId;
            }
            if (node.playerType === 'youtube') {
              return `yt${node.playerId}`;
            }
            if (node.playerType === '') {
              return foundObject?.media?.rmname === 'youtube'
                ? `yt${foundObject.media.id}`
                : foundObject?.media?.id;
            }
            return node.id;
          })();

          return (
            <div key={index}>
              <MediaPlayerWrapper
                containerId={`playerContainer_${slikeID}`}
                apiKey="test403web5a8sg6o9ug"
                slikeId={slikeID}
                Pl_Type="Video"
                autoPlay={false}
                skipAd={true}
                mute={false}
                playInBackground={true}
                pipMode={true}
              />
            </div>
          );
        }


        else if (node.contentType === 'AUDIO' && node.playerType == 'slike') {
          return (
            <div key={index}>
              <MediaPlayerWrapper
                containerId={`playerContainer_${node.id}`}
                apiKey="test403web5a8sg6o9ug"
                slikeId={node.id}
                Pl_Type="Audio"
                autoPlay={false}
                skipAd={true}
                mute={false}
                playInBackground={true}
                pipMode={true}
              />

            </div>
          )
        }
        else if (node.type == 'inlineimage') {
          let imageId = node.imageId;
          let imageSize = node.imagesize || "";
          let imageUrl = getImageUrl(imageId, imageSize, 616, undefined, baseDomain, false, constant);
  
          let imageCreditString = getImageCreditString(node.ag, node.au, node.sn, channelName);

          return (
            <div key={index} className='commonImagecreditMainWrapper' >
              <img src={imageUrl} alt={(node.altTitle ? node.altTitle : node.title)?.substring(0, 25)} width="615" height="360" />
              {node.title != '' && <div className='commonImageCeditTitle'>{node.title}</div>}
              {showImageCredits && <div className='commonImageCeditAgencyAuth'>{imageCreditString}</div>}
            </div>
          )
        }
        //Working with slideshow 
        else if (node.type == 'slideshow') {
          const imageObject = embeds && embeds.find((item: any) => item.msid == node.msid);
          return <EmbedSlider
            url={`${constant.CDS_API}/cds-feed-ext/listing/get/m360?msid=${node.msid}&fv=1000&hostId=${clientHostId}&cp=1&apiType=h&contentType=all&st=date&so=dsc`}
            baseDomain={baseDomain}
            constants={constant}
            title={imageObject?.title}
            titleseo={imageObject?.seopath}
          />

        }
        else if (node.type == 'embedgroup') {
          return (<EmbedGroupSlider
            embeds={embeds}
            slideData={node.slides}
            baseDomain={baseDomain}
            constants={constant}
            key={`embedGroup_${index}`}
            clientHostId={clientHostId}
          />)
        }
        else if (node.type == 'TOPIC' && node.tags == 'a') {
          return (<a href={node.wu} target="_self">{node.value}</a>);
        }
        else {
          return null;
        }
      }).flat();

      if(showRelatedStories && Array.isArray(relatedStories) && relatedStories.length > 0 && starKeyword) {
        parsedContent.push(
                  <div className='relatedStoriesWrapper'>
                      <p className='articleRelatedStories'>{relatedStoriesLable} {starKeyword}</p>
                      <ul>
                          {relatedStories.slice(0, 5).map((story: RelatedStory, index: number) => (
                              <li key={index}> <a href={story.wu} target="_blank" rel="noopener noreferrer">{story.hl}</a></li>
                          ))}
                      </ul>
                  </div>
              );
      }

      // Append remaining ads without offset if any
      const deviceAds = isDesktop ? bodySnippet.desktop : bodySnippet.mobile;
      if (deviceAds && deviceAds.length > 0) {
        deviceAds.forEach((ad: any, adIndex: number) => {
          if (!ad.paragraphOffset || String(ad.paragraphOffset) === '') {
            parsedContent.push(
              React.createElement(AdSlotComponent, {
                key: `extra-ad-${adIndex}`,
                headScript: ad.headScript,
                bodyScript: ad.bodyScript,
                slotNumber: adIndex,
                adSize: adSize,
                componentName: "Belly"
              })
            );
          }
        });
      }

      return <>{parsedContent}</>;
    }
    else {
      ////console.log("************Body is empty***********");
      return '';
    }
  } catch (error) {
    console.log("Some exception occured while processing Body. ", error);
  }
}


export const insertAdSlot = (index: any, bodySnippet: any, componentName: any, userAgent?: any) => {

  if (!bodySnippet) return <br key={index} />;

  let userAgentAd = null;
  if(userAgent) {
    console.log("userAgent for AMP", userAgent);
    userAgentAd = userAgent == "isDesktop" ? bodySnippet.desktop : bodySnippet.mobile;
  }
  else {
    console.log("Inside else part for adscript");
    console.log("isDesktop :::", isDesktop);
    userAgentAd = isDesktop ? bodySnippet.desktop : bodySnippet.mobile;
  }

  if (!userAgentAd || userAgentAd.length === 0) return <br key={index} />;

  return userAgentAd.map((ad: any, adIndex: any) => (
    <AdSlotComponent
      key={`${index}-${adIndex}`}
      headScript={ad.headScript}
      bodyScript={ad.bodyScript}
      slotNumber={adIndex + 1}
      adSize={ad.adSize}
      componentName={componentName}
    />
  ));
};

export const getSlideShowAd = (resultArr: any, index: number, bodySnippet: any, componentName: string) => {

  // let isBrToPush = true;
  const deviceAds = isDesktop ? bodySnippet.desktop : bodySnippet.mobile;
  if (deviceAds && deviceAds.length > 0) {
    if(index === -2) {
      deviceAds.forEach((ad: any, adindex: number) => {
        if (!ad.paragraphOffset || String(ad.paragraphOffset) === '') {
            resultArr.push(<div><AdSlotComponent
                key={`${index}-${adindex}`}
                headScript={ad.headScript}
                bodyScript={ad.bodyScript}
                slotNumber={adindex + 1}
                adSize={ad.adSize}
                componentName={componentName}
            /></div>);
            // isBrToPush = false;
        }
      });
    } else {
      deviceAds.forEach((ad: any, adindex: number) => {
        if (ad.paragraphOffset && String(ad.paragraphOffset) === String(index+1)) {
            resultArr.push(<div><AdSlotComponent
                key={`${index}-${adindex}`}
                headScript={ad.headScript}
                bodyScript={ad.bodyScript}
                slotNumber={adindex + 1}
                adSize={ad.adSize}
                componentName={componentName}
            /></div>);
            // isBrToPush = false;
        }
      });
    }
  }
  // isBrToPush && resultArr.push(<br key={index} />);
  
  return resultArr;
};

export const processArticleBody = (articleBody: any, embeds: any, cmsembeds: any, baseDomain: any, constant: any, bodySnippet: any, adSize: any) => {



  try {
    if (articleBody) {

      let ParsedContent = parseHTML(articleBody, {
        replace: (domNode: any) => {

          if (domNode.name == "keyword") {
            return <span>{domNode.attribs.keywordseo}</span>;
          }
          else if (domNode.name == "br") {
            return <br />;
          }
          else if (domNode?.attribs && domNode?.attribs?.type == "javascript") {
            return <div><Tweet tweetId='1355900161457721344' /></div>
            //return <div>{React.createElement('Tweet' as any, Twitterprops)}</div>
          }
          else if (domNode.attribs && domNode.attribs.type == "SLIKE") {
            return <div>
              <MediaPlayerWrapper
                containerId={`playerContainer_${domNode.attribs.id}`}
                apiKey="test403web5a8sg6o9ug"
                slikeId={domNode.attribs.id}
                Pl_Type={domNode.attribs.contenttype == 'AUDIO' ? 'Audio' : 'Video'}
                autoPlay={false}
                skipAd={true}
                mute={false}
                playInBackground={true}
                pipMode={true}
              />

            </div>
          }
          else if (domNode.attribs && domNode.attribs.type == "image") {

            let imageId = domNode.attribs && domNode.attribs.msid;
            let imageSize = cmsembeds[0].thumbsize || "";
            let imageUrl = getImageUrl(imageId, imageSize, 616, undefined, baseDomain, false, constant);

            return <img src={imageUrl} alt='Image Div' width="615" height="360" />
          }
        },
      });

      return ParsedContent;
    }
    else {
      ////console.log("************Body is empty***********");
      return '';
    }
  } catch (error) {
    //console.log("Some exception occured while processing Body. ", error);
  }
}
export const processArticleBodyStatic = (articleBody: any, embeds: any, cmsembeds: any, baseDomain: any, constant: any, bodySnippet: any, adSize: any) => {
  try {
    if (articleBody) {
      let ParsedContent = parseHTML(articleBody, {
        replace: (domNode: any) => {

          if (domNode.name == "keyword") {
            return <span></span>;
          }
          else if (domNode.name == "br") {
            return <br />;
          }
          else if (domNode?.attribs && domNode?.attribs?.type == "javascript") {
            return <div></div>

          }
          else if (domNode.attribs && domNode.attribs.type == "SLIKE") {
            return <div></div>
          }
          else if (domNode.attribs && domNode.attribs.type == "image") {
            return <span></span>
          }
        },
      });

      return ParsedContent;
    }
    else {
      ////console.log("************Body is empty***********");
      return '';
    }
  } catch (error) {
    //console.log("Some exception occured while processing Body. ", error);
  }
}


export const processArticleBodyAmp = (articleBody: any, embeds: any, cmsembeds: any, baseDomain: any, constant: any, bodySnippet: any, adSize: any) => {
  try {
    if (articleBody) {
      let ParsedContent = parseHTML(articleBody, {
        replace: (domNode: any) => {
          if (domNode.name == "keyword") {
            return <span>{domNode.attribs.keywordseo}</span>;
          }
          else if (domNode.name == "br") {
            return <br />;
          }
          else if (domNode.attribs && domNode.attribs.type == "javascript") {
            //const twitterId = domNode.attribs.id;
            const ampTwitterprops: any = {
              width: "600",
              height: "400",
              "data-tweetid": '1355900161457721344'
            }
            return <div>{React.createElement('amp-twitter' as any, ampTwitterprops)}</div>
          }
          else if (domNode.attribs && domNode.attribs.type == "SLIKE") {
            const ampIframeProps: any = {
              width: "600",
              height: "400",
              id: 'slikeVideo',
              'data-apikey': "test403web5a8sg6o9ug",
              'data-videoid': domNode.attribs.id,
              'data-config': "autoplay=false&skipad=false",
              'data-iframe-src': "https://tvid.in/sdk/amp/ampembed.html",
              layout: "responsive",
            }
            return <div>{React.createElement('amp-slikeplayer' as any, ampIframeProps)}</div>

          }
          else if (domNode.attribs && domNode.attribs.type == "Video") {
            let mediaId = getMediaIdFromCmsembeds(domNode.attribs.msid, cmsembeds);
            const ampIframeProps: any = {
              width: "600",
              height: "400",
              id: 'slikeVideo',
              'data-apikey': "test403web5a8sg6o9ug",
              'data-videoid': "yt" + mediaId,
              'data-config': "autoplay=false&skipad=false",
              'data-iframe-src': "https://tvid.in/sdk/amp/ampembed.html",
              layout: "responsive",
            }
            return <div>{React.createElement('amp-slikeplayer' as any, ampIframeProps)}</div>

          }
          else if (domNode.attribs && domNode.attribs.type == "image") {
            let imageId = domNode.attribs && domNode.attribs.msid;
            let imageSize = cmsembeds[0].thumbsize || "";
            let imageUrl = getImageUrl(imageId, imageSize, 616, undefined, baseDomain, false, constant);
            const imageProps: any = {
              width: "600",
              height: "400",
              layout: "responsive",
              src: imageUrl
            }
            return <div>{React.createElement('amp-img' as any, imageProps)}</div>
            //return <img src={imageUrl} alt='Image Div' width="615" height="360" />
          }

        },
      });

      return ParsedContent;
    }
    else {
      ////console.log("************Body is empty***********");
      return '';
    }
  } catch (error) {
    //console.log("Some exception occured while processing Body. ", error);
  }
}

export const processArticleBodyAmp_New = (articleBody: any, embeds: any, cmsembeds: any, baseDomain: any, constant: any, bodySnippet: any, adSize: any, channelName?: any, showImageCredits: boolean = false) => {
  try {
    let adSlotCounter = 1;
    if (articleBody) {
      let counter = 0;
      const parsedContent = articleBody.map((node: any, index: number) => {
        if (node.type === "text" && node.tags !== "strong" && node.tags !== "u" && node.tags !== "em") {
          return <span style={{ fontWeight: 'normal' }} key={index}>{node.value}</span>;
        }
        else if (node.type === "br") {
          const adElement: any[] = [];
          counter = counter + 1;
         
          if (counter === 2 && bodySnippet !== undefined && bodySnippet !== null && bodySnippet !== "") {
            counter = 0; // Reset br counter
            // const deviceAds = isDesktop ? bodySnippet.desktop : bodySnippet.mobile;
            const deviceAds = bodySnippet.mobile;
            
            // Only insert ad if we haven't exceeded the number of available ads
            if (deviceAds && deviceAds.length > 0) {
              deviceAds.forEach((ad: any, adindex: number) => {
                if (ad.paragraphOffset && String(ad.paragraphOffset) === String(adSlotCounter)) {
                  adElement.push(React.createElement(AdSlotComponent, {
                    key: `${index}-${adindex}`,
                    headScript: ad.headScript,
                    bodyScript: ad.bodyScript,
                    slotNumber: adindex,
                    adSize: adSize,
                    componentName: "BellyAmp"
                  }));
                }
              });

            }
            adSlotCounter++;
          }
          if(adElement.length === 0){adElement.push(<br key={index} />);}
          return adElement;
        }
        else if (node.type === "keyword") {
          return (<span></span>);
        }
        else if (node.type === "text" && node.tags == "strong") {
          return (<strong key={index}>{node.value}</strong>);
        }
        else if (node.type === "text" && node.tags == "span") {
          return (<span key={index}>{node.value}</span>);
        }
        else if (node.type === "text" && node.tags == "u") {
          return (<u key={index}>{node.value}</u>);
        }
        else if (node.type == "sup") {
          return (<sup key={index} dangerouslySetInnerHTML={{ __html: node.value }}></sup>);
        }
        else if (node.type === "text" && node.tags == "p") {
          return (<p key={index}>{node.value}</p>);
        }
        else if (node.tags == "em") {
          return (<i key={index}>{node.value}</i>);
        }
        else if (node.tags == "p_open") {
          return ('');
        }
        else if (node.tags == "p_close") {
          return (<div className='ptagspace' key={index} />);
        }
        else if (node.type == "link") {
          return (<a key={index} href={node.wu} target="_self">{node.value}</a>);
        } else if (node.type === "cdata" && node.subType === "twitter") {
          return (<div></div>);
        }

        // --- START: HIGHLIGHTED CHANGES ---
        // Removed redundant `else if (node.type === "cdata" && node.subType === "twitter") { return (<div></div>); }`
        // as the main cdata handler below will take care of it.

        // --- CONSOLIDATED CDATA HANDLING ---
        else if (node.type === "cdata") {
            if (node.subType === "Instagram" || node.subType === "Reels-Instagram") {
                const permalinkMatch = node.value.match(/data-instgrm-permalink="([^"]+)"/);
                const instagramUrl = permalinkMatch ? permalinkMatch[1] : null;

                if (instagramUrl) {
                    const instagramIdMatch = instagramUrl.match(/(?:reel|p)\/([a-zA-Z0-9_-]+)/);
                    const instagramId = instagramIdMatch ? instagramIdMatch[1] : null;

                    if (instagramId) {
                        const ampInstagramProps: any = {
                            'data-shortcode': instagramId,
                            'data-captioned': "true",
                            width: "600",
                            height: "600",
                            layout: "responsive",
                        };
                        return React.createElement('amp-instagram' as any, { key: `node-${index}`, ...ampInstagramProps });
                    }
                }
                return null;
            }
            else if (node.subType === "twitter" || (node.subType === "Custom" && node.value.includes('class="twitter-tweet"'))) {
                // Combine logic for both "twitter" subType and "Custom" subType containing a Twitter blockquote
                const tweetIdMatch = node.value.match(/status\/(\d+)/);
                const tweetId = tweetIdMatch ? tweetIdMatch[1] : null;

                if (tweetId) {
                    const ampTwitterProps: any = {
                        'data-tweetid': tweetId,
                        width: "375",
                        height: "472",
                        layout: "responsive",
                    };
                    return React.createElement('amp-twitter' as any, { key: `node-${index}`, ...ampTwitterProps });
                }
                // If parsing fails or not a recognizable Twitter embed, return null or empty fragment.
                return null; 
            }
            else if (node.subType === "Custom") {
                return <React.Fragment key={`node-${index}`}></React.Fragment>;
            }
            else {
                // Generic cdata handling: Determine if content is inline or block-level for AMP compliance.
                const hasBlockTags = /<(div|p|h[1-6]|ul|ol|li|table|blockquote|address|article|aside|details|figcaption|figure|footer|header|main|nav|section|pre|hr|dl|form|fieldset|menu)\b/i.test(node.value);

                // AMP does not allow arbitrary script, iframe, or blockquote tags (unless they are AMP components)
                const sanitizedValue = node.value
                    .replace(/\s(hostid|msid|type|weightage|keywordseo|source)=/g, ' data-$1=')
                    .replace(/<\/?keyword[^>]*>/g, '')
                    .replace(/ contenteditable="false"/g, '')
                    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
                    .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, '')
                    .replace(/<blockquote\b[^<]*(?:(?!<\/blockquote>)<[^<]*)*<\/blockquote>/gi, ''); // Remove blockquote if not specifically for amp-twitter/ExtQuote

                if (hasBlockTags) {
                    // Render as a div for block-level content.
                    const classMapping: { [key: string]: string } = {
                        '<ul>': 'list-ul-class',
                        '<ol>': 'list-ol-class',
                        '<table>': 'list-table-class',
                    };
                    const tag = Object.keys(classMapping).find((key) => node.value.startsWith(key));
                    const className = tag ? classMapping[tag] : 'custon-default-class';
                    return <div className={className} key={`node-${index}`} dangerouslySetInnerHTML={{ __html: sanitizedValue }}></div>;
                } else {
                    // Render as a span for inline content.
                    return <span key={`node-${index}`} dangerouslySetInnerHTML={{ __html: sanitizedValue }}></span>;
                }
            }
        }
        // --- END: HIGHLIGHTED CHANGES ---
      else if (node.type === 'inlinevideo' && node.playerType === 'youtube') {
        const ampYoutubeProps: any = { // Renamed for clarity
          'data-videoid': node.id.replace('yt', ''), // Ensure ID is just the YouTube video ID
          width: "600",
          height: "400",
          layout: "responsive",
        };
        return React.createElement('amp-youtube' as any, { key: `node-${index}`, ...ampYoutubeProps });
      }
      else if (node.contentType === 'VIDEO' && node.playerType === 'slike') {
        const ampSlikePlayerProps: any = { // Renamed for clarity
          width: "600",
          height: "400",
          id: `slikeVideo-${index}`, // Make ID unique if multiple players
          'data-apikey': "test403web5a8sg6o9ug",
          'data-videoid': node.id,
          'data-config': "autoplay=false&skipad=false",
          'data-iframe-src': "https://tvid.in/sdk/amp/ampembed.html",
          layout: "responsive",
        };
        return React.createElement('amp-slikeplayer' as any, { key: `node-${index}`, ...ampSlikePlayerProps });
      }
      else if (node.contentType === 'AUDIO' && node.playerType === 'slike') {
        // AMP requires amp-audio or similar component. Return empty fragment for now.
        return <React.Fragment key={`node-${index}`}></React.Fragment>;
      }
        else if (node.type == 'inlineimage') {
          let imageId = node.imageId;
          let imageSize = node.imagesize || "";
          let imageUrl = getImageUrl(imageId, imageSize, 616, undefined, baseDomain, false, constant);

          let imageCreditString = getImageCreditString(node.ag, node.au, node.sn, channelName);

          const imageProps: any = {
            width: "600",
            height: "400",
            layout: "responsive",
            src: imageUrl,
            alt: node.altTitle || node.title || 'Image',
          }
          // return <><div>{React.createElement('amp-img' as any, imageProps)}</div>
          //   <div className='ampCommonImagecreditMainWrapper'>
          //     <div>{node.title != '' && <div className='ampCommonImageCeditTitle'>{(node.altTitle ? node.altTitle : node.title)?.substring(0, 25)}</div>}
          //       {showImageCredits && (node.ag || node.au) && <div className='ampCommonImageCeditAgencyAuth'>{imageCreditString}</div>}</div>
          //   </div>
          // </>
        return (
          <React.Fragment key={`node-${index}`}>
            {React.createElement('amp-img' as any, imageProps)}
            {(node.title || node.altTitle || (showImageCredits && (node.ag || node.au))) && ( // Condition for rendering wrapper div
              <div className='ampCommonImagecreditMainWrapper'>
                <div>
                  {node.title !== '' && <div className='ampCommonImageCeditTitle'>{(node.altTitle ? node.altTitle : node.title)?.substring(0, 25)}</div>}
                  {showImageCredits && <div className='ampCommonImageCeditAgencyAuth'>{imageCreditString}</div>}
                </div>
              </div>
            )}
          </React.Fragment>
        );

        }      // Working with slideshow
        else if (node.type === 'Slideshow') {
        // AMP slideshows need amp-carousel or similar. Return empty fragment for now.
        return <React.Fragment key={`node-${index}`}></React.Fragment>;
      }
        else if (node.type == 'Slideshow') {
          return (<div></div>)
        }
      //    else if (node.type === 'TOPIC' && node.tags === 'a') {
      //   const isExternal = node.wu && node.wu.startsWith('http') && !node.wu.includes(baseDomain);
      //   return (
      //     <a
      //       key={`node-${index}`}
      //       href={node.wu}
      //       target={isExternal ? "_blank" : "_self"}
      //       {...(isExternal && { rel: "noopener noreferrer" })}
      //     >
      //       {node.value}
      //     </a>
      //   );
      // } will use this if in case of below topic will not work
        else if (node.type == 'TOPIC' && node.tags == 'a') {
          return (<a href={node.wu} target="_self">{node.value}</a>);
        }
        else {
          return null;
        }
      }).flat();

      // Append remaining ads without offset if any
      // const deviceAds = isDesktop ? bodySnippet.desktop : bodySnippet.mobile;
      const deviceAds = bodySnippet.mobile;
      if (deviceAds && deviceAds.length > 0) {
        deviceAds.forEach((ad: any, adIndex: number) => {
          if (!ad.paragraphOffset || String(ad.paragraphOffset) === '') {
            parsedContent.push(
              React.createElement(AdSlotComponent, {
                key: `extra-ad-${adIndex}`,
                headScript: ad.headScript,
                bodyScript: ad.bodyScript,
                slotNumber: adIndex,
                adSize: adSize,
                componentName: "Belly"
              })
            );
          }
        });
      }

      return <>{parsedContent}</>;
    }
    else {
      ////console.log("************Body is empty***********");
      return '';
    }
  } catch (error) {
    //console.log("Some exception occured while processing Body. ", error);
  }
}

export const processArticleNewBody = (articleBody: any, embeds: any, cmsembeds: any, baseDomain: any, constant: any, bodySnippet: any, adSize: any) => {
  try {
    if (articleBody) {
      let imageUrl = "";

      let htmlBody = new DOMParser().parseFromString(articleBody, 'text/html');

      if (embeds && embeds.length > 0 && htmlBody.body.getElementsByTagName('div').length > 0) {
        for (let index = 0; index < embeds.length; index++) {
          const embed = embeds[index];
          //Working with images
          if (embed && embed.type == 'image') {
            for (let index = 0; index < cmsembeds.length; index++) {
              const cmsembed = cmsembeds[index];
              if (cmsembed.msid === embed.msid && cmsembed.cmstype == 'IMAGES') {
                const allDivs: any = htmlBody.body.getElementsByTagName('div');
                for (let i = 0; i < allDivs.length; i++) {
                  const allDiv = allDivs[i];
                  if (allDiv.attributes.type && allDiv.attributes.type?.value === 'image' && allDiv.attributes.msid?.value === cmsembed.msid) {
                    let imageId = allDiv.attributes.msid.value;
                    let imageSize = cmsembed.thumbsize ? cmsembed.thumbsize : '';
                    if (!imageSize) {
                      ////console.log('Image Size is empty for embed image..');
                      allDiv.replaceWith(`<span></span>`);
                      break;
                    }
                    imageUrl = getImageUrl(imageId, imageSize, 616, undefined, baseDomain, false, constant);
                    var temp = document.createElement('span');
                    let imageDiv = `<img src=${imageUrl} alt='Image Div' width="615" height="360" />`;
                    temp.innerHTML = imageDiv;
                    allDiv.replaceWith(temp);
                    break;
                  }
                }
                break;
              }
            }
          }


        }
      }






      if (bodySnippet !== undefined && bodySnippet !== null && bodySnippet !== "") {
        let bodyText = htmlBody.body.innerText || "";
        let currentIndex = 0;
        if (currentIndex < bodyText.length) {
          let endIndex = currentIndex + 500;
          if (endIndex < bodyText.length) {
            endIndex = htmlBody.body.innerHTML.indexOf('<br>', endIndex);
            if (endIndex === -1) {
              endIndex = currentIndex + 500;
            }
            let finalBodySnippet: String = '';
            finalBodySnippet = `<div id='belly_ad_slot_1' style='width: 300px;height: 250px;margin: 0 auto;'>${bodySnippet}</div>`;
            htmlBody.body.innerHTML = `${htmlBody.body.innerHTML.slice(0, endIndex)}<br><br>${finalBodySnippet}${htmlBody.body.innerHTML.slice(endIndex)}`;
            currentIndex = endIndex + finalBodySnippet.length + 1;
          }
        }
      }
      return htmlBody.body.innerHTML;
    }
    else {
      ////console.log("************Body is empty***********");
      return '';
    }
  } catch (error) {
    //console.log("Some exception occured while processing Body. ", error);
  }
}
export const processArticleNewBody2 = (articleBody: any, embeds: any, cmsembeds: any, baseDomain: any, constant: any, bodySnippet: any, adSize: any) => {

  let htmlBody = new DOMParser().parseFromString(articleBody, 'text/html');

  try {
    if (articleBody) {
      //let brcount: any=0;
      //let brCount = 0; // Counter for <br/> tags
      let test = Parser(articleBody, {
        replace: (domNode: any) => {

          // if (domNode.name == "br" && (bodySnippet !== undefined && bodySnippet !== null && bodySnippet !== "")) {
          //   brCount++;
          //   if (brCount == 3 ) {
          //     return <div className="container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          //       <div className="ad-box" style={{ width: '300px', height: '250px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f0f0f0' }}>Ad Slot<br />300 X 250</div>
          //     </div>
          //   }
          //   if (brCount == 6) {
          //     return <div id='belly_ad_slot_1' style={{width: '300px',height: '250px',margin: '0 auto'}}>${bodySnippet}</div>
          //   }

          // }

          if (domNode.name == "keyword") {
            return <span>{domNode.attribs.keywordseo}</span>;
          }
          else if (domNode.attribs && domNode.attribs.type == "image") {

            let imageId = domNode.attribs && domNode.attribs.msid;

            let imageSize = cmsembeds[0].thumbsize || "";
            let imageUrl = getImageUrl(imageId, imageSize, 616, undefined, baseDomain, false, constant);

            return <img src={imageUrl} alt='Image Div' width="615" height="360" />
          }
          else if (domNode.attribs && (domNode.attribs.type == "twitter" || domNode.attribs?.type == "Youtube" || domNode.attribs?.type == "Linkedin" || domNode.attribs?.type == "facebook" || domNode.attribs?.type == "instagram" || domNode.attribs?.type == "wikipedia")) {
            return <span></span>
          }
          else if (domNode.attribs && domNode.attribs.type == "iframe") {
            const ampIframeProps: any = {
              width: "600",
              height: "400",
              title: "Google map pin on Googleplex, Mountain View CA",
              layout: "responsive",
              sandbox: "allow-scripts allow-same-origin allow-popups",
              frameborder: "0",
              src: "https://www.google.com/maps/embed/v1/place?q=place_id:ChIJ2eUgeAK6j4ARbn5u_wAGqWA&key=YOUR_GOOGLE_MAPS_API_KEY",
            }
            return <div>{React.createElement('amp-iframe' as any, ampIframeProps)}</div>
          }
          else if (bodySnippet !== undefined && bodySnippet !== null && bodySnippet !== "") {
            let bodyText = htmlBody.body.innerText || "";
            let currentIndex = 0;
            if (currentIndex < bodyText.length) {
              let endIndex = currentIndex + 500;
              if (endIndex < bodyText.length) {
                endIndex = htmlBody.body.innerHTML.indexOf('<br>', endIndex);
                if (endIndex === -1) {
                  endIndex = currentIndex + 500;
                }
                let finalBodySnippet: String = '';
                finalBodySnippet = `<div id='belly_ad_slot_1' style='width: 300px;height: 250px;margin: 0 auto;'>${addDataPosition(bodySnippet, "1")}</div>`;
                htmlBody.body.innerHTML = `${htmlBody.body.innerHTML.slice(0, endIndex)}<br><br>${finalBodySnippet}${htmlBody.body.innerHTML.slice(endIndex)}`;
                currentIndex = endIndex + finalBodySnippet.length + 1;
              }
            }
          }
        },
      });

      return test;
    }
    else {
      ////console.log("************Body is empty***********");
      return '';
    }
  } catch (error) {
    //console.log("Some exception occured while processing Body. ", error);
  }
}

export const getListButtonIcon = (type: any) => {
  let button = null;
  if (type == "MEDIAAUDIO") {
    // button = <MicIcon />;
    button = <PodcastsIcon />;
  }
  else if (type == "PHOTOLIST") {
    button = <CollectionsIcon />
  }
  else {
    button = <PlayCircleOutlinedIcon />
    // button = <PodcastsOutlinedIcon />
  }
  return button;
}

export const getListButtonIconPlain = (type: any) => {
  let button = null;
  if (type == "MEDIAAUDIO") {
    // button = <MicIcon />;
    button = <PodcastsIcon />;
  }
  else if (type == "PHOTOLIST") {
    button = <CollectionsIcon />
  }
  else {
    button = <PlayArrowRoundedIcon />
    // button = <PodcastsOutlinedIcon />
  }
  return button;
}


export const handleSearchClick = (searchValue: any, hostId?: any) => {
  if (searchValue == "") {
    return;
  }

  if (typeof window !== 'undefined' && undefined !== window && window
    && !PAGEBUILDER_URLS.some(domain => window.location.origin.includes(domain))) {

    fetchMedleyData(hostId, searchValue)
      .then(response => {
        console.log("fetchMedleyData response : ", response);

        if (response && response.data && response.data.length > 0 && response.data[0].topics && response.data[0].topics.length > 0) {

          const searchValue = response.data[0].topics[0].uid;
          let url = `${window.location.origin}/topics/${searchValue}`;
          window.open(url);

        } else {
          let url = `${window.location.origin}/topics/${searchValue}`;
          window.open(url);
        }

      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
}


export function getImageCreditString(nodeAgency: any, nodeAuthor: any, imageSourceName: any, channelName: any = "Publish Story") {
  let imageAgency = '';
  let imageAuthors = '';
  let defalultCredit = '';
  try{
    //Correcting the spaces in node authors
    if (nodeAuthor && nodeAuthor.length > 0) {
      imageAuthors = nodeAuthor.replace(/\s*,\s*/g, ', ').trim();
    }

    if(imageSourceName && imageSourceName.length > 0) {
      imageSourceName = imageSourceName.replace(/\s*,\s*/g, ', ').trim();
    }

    if (nodeAgency && nodeAgency.length > 0) {
      imageAgency = nodeAgency.replace(/\s*,\s*/g, ', ').trim();
    }
    
    if (imageAuthors || imageAgency || imageSourceName) {
      defalultCredit = imageSourceName;
    } else if (channelName) {
      defalultCredit = channelName;
    } else {
      defalultCredit = "Publish Story";
    }
    
  } catch (error) {
    console.error("Error getImageCreditString : ", error);
  }

  const imageCredit = 
    (imageAuthors ? imageAuthors : '') +
    (imageAgency && imageAuthors ? ', ' : '') +
    (imageAgency ? imageAgency : '') +
    ((imageAgency || imageAuthors) && defalultCredit ? ', ' : '') +
    (defalultCredit ? defalultCredit : '');

  return (
    <>
      ( <span>Image credit :</span> {imageCredit} )
    </>
  );
}

export function fetchMedleyData(hostId: any, key: any) {

  const url = 'https://cdsfeed-ext.indiatimes.com/cds-feed-ext/jcms/cloud/medley';

  const data = {
    tenantId: hostId,
    key: key,
    searchTitleFlag: true,
    searchAliasesFlag: true,
    exactMatchQueryFlag: true
  };

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then(result => {
      return result; // Return the result to the caller
    })
    .catch(error => {
      console.error('Error fetching data:', error);
      throw error; // Re-throw error for handling by the caller if needed
    });
}

// let processedIds = new Set();
// setInterval(() => {
//   processedIds.clear();
// }, 10000);

export const refreshTheAd = (htmlString: String, refreshAdPg: any, setRefreshAdPg: any, currentPageIndex: any) => {
  if (htmlString && String(htmlString).includes("colombia") && refreshAdPg !== currentPageIndex) {
    const matches = htmlString.match(/id="([^"]+)"/g);

    if (matches !== null && matches.length > 0) {
      const lastMatch = matches[matches.length - 1];
      const idValueMatch = lastMatch.match(/id="([^"]+)"/);

      if (idValueMatch !== null) {
        const idPositionValue = idValueMatch[1];

        setTimeout(() => {
          const value = idPositionValue;
          try {
            if (typeof eval("colombia") !== 'undefined' && typeof eval("colombia.refresh") === 'function') {
              eval(`colombia.refresh("${value}")`);
            }
          } catch (error) {
            console.error("Error refreshing Colombia:", error);
          }
        }, 2000);

        setRefreshAdPg(currentPageIndex);
      }
    }

  }
}

export const addDataPosition = (htmlString: String, index: any) => {
  //if Colombia Ad Network add data-position based on data-slot
  if (htmlString && String(htmlString).includes("colombia")) {
    return htmlString.replace(/data-slot="(\d+)"/g, (match, dataSlotValue) => {
      const dataPositionValue = dataSlotValue + index;
      return `data-slot="${dataSlotValue}" data-position="${dataPositionValue}"`;
    }).replace(/id="([^"]+)"/g, (match, idValue) => {
      const idPositionValue = idValue + index;
      return `id="${idPositionValue}"`;
    }).replace(/name="([^"]+)"/g, (match, nameValue) => {
      const namePositionValue = nameValue + index;
      return `name="${namePositionValue}"`;
    });
  } else {
    return htmlString;
  }
}

export const getLoggedUserName = () => {
  const match = document.cookie.match(new RegExp('(^| )otpless=([^;]+)'));
  console.log("matchmatch", match);
  let data: any = match ? decodeURIComponent(match[2]) : null;
  console.log("datadata", data);
  if (data) {
    const userName: any = atob(data);
    console.log("userNameuserName", userName);
    if (userName) {
      return JSON.parse(userName).name;
    }
  }

  return null;
}

export const getLoggedUserEmail = () => {
  const match = document.cookie.match(new RegExp('(^| )otpless=([^;]+)'));
  console.log("matchmatch", match);
  let data: any = match ? decodeURIComponent(match[2]) : null;
  console.log("datadata", data);
  if (data) {
    const userName: any = atob(data);
    console.log("userNameuserName", userName);
    if (userName) {
      return JSON.parse(userName).email;
    }
  }
  return null;
}

export const getLoggedInFlag = () => {
  const match = document.cookie.match(new RegExp('(^| )cauth=([^;]+)'));
  console.log("matchmatch", match);
  let data: any = match ? decodeURIComponent(match[2]) : null;
  if (data) {
    return true;
  }
  return false;
}

export const logoutUser = () => {
  localStorage.removeItem('auth-user');
  document.cookie = 'otpless=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  window.location.reload();
}

export const isLoggedIn = () => {
  const match = document.cookie.match(new RegExp('(^| )otpless=([^;]+)'));
  let data: any = match ? decodeURIComponent(match[2]) : null;

  const cmatch = document.cookie.match(new RegExp('(^| )cauth=([^;]+)'));
  let cdata: any = cmatch ? decodeURIComponent(cmatch[2]) : null;

  if (cdata) {
    if (data) {
      return true;
    } else {
      window.location.href = "/login?url=" + encodeURIComponent(window.location.href);
      return;
    }
  } else {
    return true;
  }
}

export const setCookie = (name: string, value: string, days: number) => {
  const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/`;
};
export const getCookie = (name: string) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift();
};

export const fetchAnchorValue = (anchorLinksValue: boolean, url: any) => {

  if (url && url.startsWith('http')) {
    //console.log("URL contains HTTP/HTTPS");
    return "_blank";
  }

  if (anchorLinksValue == false) {
    return "_self";
  }
  else if (anchorLinksValue == true) {
    return "_blank";
  }
  else {
    return "_self";
  }
};
export const safeCharAt = (value: string, index = 0) => {
  const stringValue = String(value || "");
  return stringValue.charAt(index);
}

export const getAnchorUrl = (domainUrl: string, path: string) => {
  if (!domainUrl) { return }
  let updatedDomain = domainUrl;
  if (domainUrl.length > 0 && domainUrl[domainUrl.length - 1] == "/") {
    updatedDomain = domainUrl.substring(0, domainUrl.length - 1)
  }

  if (path.includes("http://") || path.includes("https://")) {
    updatedDomain = path;
  } else {
    updatedDomain = updatedDomain + path;
  }

  return updatedDomain;
}


export const isCSR = () => {
  if (typeof window !== 'undefined' && undefined !== window && window) {
    return true;
  } else {
    return false;
  }
}


export const validateAdScript = (inputString: any) => {
  const scriptTagRegex = /<script\b[^>]*>([\s\S]*?)<\/script>/;
  const match = inputString.match(scriptTagRegex);
  return match !== null && match[0] === inputString;
}

export function getAuthorCard(props: any, authorData: any) {
  const getSocialMediaIcons = () => {
    const { socialmediaprofile } = authorData;
    let result = [];
    for (let key in socialmediaprofile) {
      if (key != "hostid") {
        const iconType = getSocialClassName(key, 1, 'author');
        result.push(<li>
          <a className="toTwitter" href={socialmediaprofile[key]} target="_self">
            {/* <FdontAwesomeIcon icon={getSocialClassName(key)} /> */}
            <div className={`sprite-icon ${iconType}`} style={{ backgroundImage: `url(${GetIconsSprites()})` }} />
          </a>
        </li>)
      }
    }

    return result;
  }

  const getAuthorLink = () => {
    if (typeof authorData?.pubInfo != "undefined" && authorData?.pubInfo != null) {
      const { pubInfo, personalprofile, id } = authorData;
      let url = pubInfo.baseDomain;
      let finalUrl = `${url}${personalprofile.seoname}/author/${id}.html`;
      if (!url) finalUrl = `/${finalUrl}`;
      return finalUrl;
    }
  }

  return (
    <div className='commoncontainer'>
      <Grid item md={12} xs={12}>
        <div className='authorbiowrap'>
          <div className='authorbioimagewrap'>
            <div className='authorbioimage'>
              <div className="manageimagewrap">

                {/* {authorData && Object.keys(authorData).length && getImageSize(authorData.imageid) &&
                  (<picture>
                    <source media="(min-width: 768px)" srcSet={getImageUrl(getImageId(authorData.imageid), getImageSize(authorData.imageid), 290, undefined, authorData && authorData.pubInfo.baseDomain, true, props.CONSTANTS)} />
                    <source media="(min-width: 320px)" srcSet={getImageUrl(getImageId(authorData.imageid), getImageSize(authorData.imageid), 320, undefined, authorData && authorData.pubInfo.baseDomain, true, props.CONSTANTS)} />
                    {<img src={getImageUrl(getImageId(authorData.imageid), getImageSize(authorData.imageid), 290, undefined, authorData && authorData.pubInfo.baseDomain, true, props.CONSTANTS)} alt={authorData?.name} title={authorData?.name} />}
                  </picture>)
                } */}
                <div className="author__info for-mobile">
                  <div className='authormainbio'>
                    <a className="author_name" href={getAuthorLink()} target="_self">{authorData && authorData.name}</a>
                  </div>


                  <div className="authornewrap">
                    {<span className='authorreport authorreport-desktop'>{authorData && authorData.professionalprofile &&
                      authorData.professionalprofile.authortype}</span>}

                    {authorData && authorData.socialmediaprofile &&

                      <ul className="author-social-icon">
                        {getSocialMediaIcons()}
                      </ul>
                    }
                  </div>
                </div>
              </div>
            </div>
            <div className='manageauthordiv'>
              <div className="author__info for-desktop">
                <div className='authormainbio'>
                  <a className="author_name" href={getAuthorLink()} target="_self">{authorData && authorData.name}</a>
                </div>


                <div className="authornewrap">
                  {<span className='authorreport authorreport-desktop'>{authorData && authorData.professionalprofile &&
                    authorData.professionalprofile.authortype}</span>}

                  {authorData && authorData.socialmediaprofile &&

                    <ul className="author-social-icon">
                      {getSocialMediaIcons()}
                    </ul>
                  }
                </div>
              </div>
              {authorData && authorData.personalprofile &&
                <p dangerouslySetInnerHTML={{ __html: authorData.personalprofile.bio }} />}
            </div>
          </div>
        </div>
        <div className='clearfix'></div>
      </Grid>
    </div>
  )
}



export function getAuthorCardThree(props: any, authorData: any) {
  const cache = getMUICache();
  const { showDepartment, anchorLinksValue } = props;
  
  const getAuthorLink = () => {
    if (typeof authorData?.pubInfo != "undefined" && authorData?.pubInfo != null) {
      const { pubInfo, personalprofile, id } = authorData;
      let url = pubInfo.baseDomain;
      let finalUrl = `${url}${personalprofile.seoname}/author/${id}.html`;
      return finalUrl;
    }
  }

  return (
    <div className='commoncontainer'>
      <CacheProvider value={cache}>
        <div className='themeThreeAuthorShowWrapper'>
         
          <div className='themeThreeAuthorDetailWrap'>
            <p className='themeThreeAuthorProfession'>{showDepartment && <span className='authorreport authorreport-desktop'>{authorData && authorData?.professionalprofile &&
              authorData?.professionalprofile?.authortype}</span>}</p>
            <p className='themeThreeAuthorName'><a className="author_name" href={getAuthorLink()} target={fetchAnchorValue(anchorLinksValue, getAuthorLink())}>{authorData && authorData?.name}</a></p>
            {authorData && authorData.personalprofile &&
              <div className="desktopDiscriptonAuthor"><p className='themeThreeAuthorDetails' dangerouslySetInnerHTML={{ __html: authorData.personalprofile.bio }} /></div>}
          </div>
        </div>
        {authorData && authorData.personalprofile && <div className="mobileDiscriptonAuthor"><p className='themeThreeAuthorDetails' dangerouslySetInnerHTML={{ __html: authorData.personalprofile.bio }} /></div>}
      </CacheProvider>
    </div>
  )
}

export const isUpdatedWithin24Hours = (timestampStr: any, updatedate: any = "0"): boolean => {
  // console.log('isUpdatedWithin ::' , timestampStr)
  // console.log('isUpdatedWithin24Hours ::' , updatedate)
  if( !timestampStr && (!updatedate || updatedate == "0") ) return false;
  else if(!timestampStr && updatedate) timestampStr = updatedate.toString();

  // Check if input is a numeric string (optional whitespace is trimmed)
  if (!/^\d+$/.test(timestampStr.trim())) {
    return false;
  }

  const timestampNum = Number(timestampStr.trim());

  // Normalize to milliseconds if it's in seconds
  const inputTime = timestampNum < 1e12 ? timestampNum * 1000 : timestampNum;

  const now = Date.now(); // current time in ms
  const hours24 = 24 * 60 * 60 * 1000;

  return now - inputTime <= hours24;
};

// Function to calculate relative time ago string
export const getTimeAgo = (timestamp: any, updatedate: any = "0") => {

  if( !timestamp && (!updatedate || updatedate == "0") ) return "";
  else if(!timestamp && updatedate) timestamp = updatedate.toString();

  if (!timestamp) return '';

  const now = new Date();
  const past = new Date(typeof timestamp === 'string' ? parseInt(timestamp) : timestamp);
  const diffMs = now.getTime() - past.getTime();

  const seconds = Math.floor(diffMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) return `${days} day${days > 1 ? 's' : ''} ago`;
  if (hours > 0) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  if (minutes > 0) return `${minutes} min${minutes > 1 ? 's' : ''} ago`;
  return 'Just now';
};

export const AuthorCardTwo: FC<{ props: any; authorData: any }> = ({ props, authorData }): JSX.Element => {
  const [bioHtml, setBioHtml] = useState('');
  const cache = getMUICache();

  const getAuthorLink = (): string => {
    const { personalprofile, id } = authorData || {};
    const seoName = personalprofile?.seoname;

    if (!seoName || !id) return '#';

    if (typeof window !== 'undefined') {
      const origin = window.location.origin; 
      return `${origin}/${seoName}/author/${id}.html`;
    }

    return `/${seoName}/author/${id}.html`;
  };

  const truncateHtmlByTextLength = (html: string, limit: number, authorLink: string): string => {
    if (typeof document === 'undefined') return '';

    const div = document.createElement('div');
    div.innerHTML = html;

    let charCount = 0;
    let appended = false;

    function truncateNode(node: Node): Node | null {
      if (charCount >= limit) return null;

      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent || '';
        const remaining = limit - charCount;
        const truncatedText = text.slice(0, remaining);
        charCount += truncatedText.length;

        if (charCount >= limit && !appended) {
          appended = true;
          return document.createTextNode(`${truncatedText}... `);
        }

        return document.createTextNode(truncatedText);
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node as HTMLElement;
        const cloned = element.cloneNode(false) as HTMLElement;

        for (const child of Array.from(node.childNodes)) {
          const truncatedChild = truncateNode(child);
          if (truncatedChild) {
            cloned.appendChild(truncatedChild);
          }
          if (charCount >= limit) break;
        }

        return cloned;
      }

      return null;
    }

    const truncated = truncateNode(div);
    const wrapper = document.createElement('div');
    if (truncated) wrapper.appendChild(truncated);

    if (charCount >= limit && !appended) {
      wrapper.innerHTML += `... `;
    }

    const anchor = document.createElement('a');
    anchor.href = authorLink;
    anchor.target = '_blank';
    anchor.className = 'author_name';
    anchor.innerText = 'Read more';
    wrapper.appendChild(anchor);

    return wrapper.innerHTML;
  };

  const stripHtml = (html: string): string => html.replace(/<[^>]*>/g, '');

  const plainBio = authorData?.personalprofile?.bio
    ? stripHtml(authorData.personalprofile.bio)
    : '';

  useEffect(() => {
    if (typeof window !== 'undefined' && authorData?.personalprofile?.bio) {
      const plainTextBio = stripHtml(authorData.personalprofile.bio);
      if (plainTextBio.length > 180) {
        setBioHtml(truncateHtmlByTextLength(authorData.personalprofile.bio, 180, getAuthorLink()));
      } else {
        setBioHtml(authorData.personalprofile.bio);
      }
    }
  }, [authorData]);

  return (
    <div className='commoncontainer articleAuthorThemeTwo'>
      <CacheProvider value={cache}>
        <div className='themeTwoAuthorShowWrapper'>
          <div className='themeTwoAuthorShowImageWrap'>
            {authorData && Object.keys(authorData).length && getImageSize(authorData.imageid) && (
              <picture>
                <source
                  media="(min-width: 768px)"
                  srcSet={getImageUrl(
                    getImageId(authorData.imageid),
                    getImageSize(authorData.imageid),
                    113,
                    '',
                    authorData?.pubInfo?.baseDomain,
                    true,
                    props.CONSTANTS
                  )}
                />
                <source
                  media="(min-width: 320px)"
                  srcSet={getImageUrl(
                    getImageId(authorData.imageid),
                    getImageSize(authorData.imageid),
                    84,
                    '',
                    authorData?.pubInfo?.baseDomain,
                    true,
                    props.CONSTANTS
                  )}
                />
                <img alt={authorData?.name} title={authorData?.name} loading="lazy" />
              </picture>
            )}
          </div>

          <div className='themeTwoAuthorDetailWrap'>
            <p className='themeTwoAuthorProfession'>
              {authorData?.professionalprofile?.authortype && (
                <span className='authorreport authorreport-desktop'>
                  {authorData.professionalprofile.authortype}
                </span>
              )}
            </p>

            <p className='themeTwoAuthorName'>
              <a className='author_name' target='_blank' href={getAuthorLink()}>
                {authorData?.name}
              </a>
            </p>

            <div className='themeTwoAuthorCardSocial'>
              <ul>
                {authorData?.socialmediaprofile?.facebookprofilepage?.trim() && (
                  <li>
                    <a className='toFb' href={authorData.socialmediaprofile.facebookprofilepage} target='_blank'>
                      <div className='bg-Facebook_icon_T2' style={{ backgroundImage: `url(${GetIconsSprites()})` }} />
                    </a>
                  </li>
                )}
                {authorData?.socialmediaprofile?.twitterhandle?.trim() && (
                  <li>
                    <a className='toTw' href={authorData.socialmediaprofile.twitterhandle} target='_blank'>
                      <div className='bg-X_icon_T2' style={{ backgroundImage: `url(${GetIconsSprites()})` }} />
                    </a>
                  </li>
                )}
                {authorData?.socialmediaprofile?.linkedinurl?.trim() && (
                  <li>
                    <a className='toIn' href={authorData.socialmediaprofile.linkedinurl} target='_blank'>
                      <div className='bg-in_icon_T2' style={{ backgroundImage: `url(${GetIconsSprites()})` }} />
                    </a>
                  </li>
                )}
                {authorData?.socialmediaprofile?.instagramurl?.trim() && (
                  <li>
                    <a className='toIns' href={authorData.socialmediaprofile.instagramurl} target='_blank'>
                      <div className='bg-Instagram_icon_T2' style={{ backgroundImage: `url(${GetIconsSprites()})` }} />
                    </a>
                  </li>
                )}
                {authorData?.socialmediaprofile?.youtubeurl?.trim() && (
                  <li>
                    <a className='toYt' href={authorData.socialmediaprofile.youtubeurl} target='_blank'>
                      <div className='bg-Youtube_icon_T2' style={{ backgroundImage: `url(${GetIconsSprites()})` }} />
                    </a>
                  </li>
                )}
                {authorData?.socialmediaprofile?.pinteresturl?.trim() && (
                  <li>
                    <a className='toPnt' href={authorData.socialmediaprofile.pinteresturl} target='_blank'>
                      <div className='bg-Pinterest_icon_T2' style={{ backgroundImage: `url(${GetIconsSprites()})` }} />
                    </a>
                  </li>
                )}
              </ul>
            </div>

            <div className='desktopDiscriptonAuthor'>
              {bioHtml && (
                <div className='themeTwoAuthorDetails' dangerouslySetInnerHTML={{ __html: bioHtml }} />
              )}
            </div>
          </div>
        </div>

        {plainBio && (
          <div className='mobileDiscriptonAuthor'>
            {bioHtml && (
              <div className='themeTwoAuthorDetails' dangerouslySetInnerHTML={{ __html: bioHtml }} />
            )}
          </div>
        )}
      </CacheProvider>
    </div>
  );
};

export const getAuthorCardTwo = (props: any, authorData: any): JSX.Element => {
  return <AuthorCardTwo props={props} authorData={authorData} />;
};
